import React, { useState, useEffect, useRef } from "react";

import useFetch from "../../hooks/useFetch";
import usePost from "../../hooks/usePost";
import usePut from "../../hooks/usePut";
import { useZones } from "../../hooks/useZones";
import { useGetCity } from "../../hooks/useGetCity";
import { useGetArea } from "../../hooks/useGetArea";
import { usePaymentMethods } from "../../hooks/usePaymentMethods";
import useFoloosiReferenceToken from "../../hooks/useFoloosiReferenceToken";
import useNetworkPayment from "../../hooks/useNetworkPayment";
import { useShippingProviders } from "../../hooks/useShippingProviders";
import { useShippingRates } from "../../hooks/useShippingRates";
import useDHLShipping from "../../hooks/useDHLShipping";
import useSMSAShipping from "../../hooks/useSMSAShipping";
import useNetGlobalShipping from "../../hooks/useNetGlobalShipping";
import useSettings from "../../hooks/useSettings";
import useGetOffers from "../../hooks/useGetOffers";
import useGetClearances from "../../hooks/useGetClearances";
import useGetFixedShipping from "../../hooks/useGetFixedShipping";
import { useAddress } from "../../hooks/useAddress";
import { makeRequest } from "../../makeRequest";
import { useAddressesFetch, buildAddressesUrl } from "../../hooks/useAddressesFetch";

import {
  applyDiscountRules,
  generateUser,
  isPhoneValid,
  updateCountryFromPhoneNumber,
  isPromoValid,
  getFreshPromo,
  getShippingRate,
  getFreshActiveShippingProviders,
  getFreshStaticShippingRate,
  fetchFreshShippingRates,
  getColorAndSize,
  getButton,
  calculateWeight,
  subscribeToNewsletter,
  generateInvoiceNumber,
  generatePackageID,
  uploadBase64PdfToStrapi,
  updateOrderWithInvoice,
  applyOffers,
  applyClearances,
  checkCustomShippingRates,
  calculateFreeShipping,
  getUserPoints,
  getProductsQuantities,
  convertHTMLToPdf,
  uploadPdfToStrapi,
} from "../../helpers/common";
import { calculateOrderTotals } from "../../helpers/orderTotals";

import { useDispatch, useSelector } from "react-redux";
import {
  enableIsPromoApplied,
  disableIsPromoApplied,
  enableIsVoucher,
  disableIsVoucher,
  setVoucherAmount,
  addPromo,
  removePromo,
  addPoints,
  removePoints,
  addShippingData,
  setOrderID,
  removeOrderID,
  removeShippingData,
} from "../../redux/checkoutReducer";
import { setUser } from "../../redux/userReducer";
import { setDiscountRules } from "../../redux/discountRulesReducer";

import { Link, useNavigate, useLocation } from "react-router-dom";

import "./Checkout.scss";
import { ReactComponent as UAEDirham } from "../../SVGs/UAEDirham.svg";
import { ReactComponent as MapPin } from "../../SVGs/MapPin.svg";

import SelectWithInnerLabel from "../../components/SelectWithInnerLabel/SelectWithInnerLabel";
import InputWithInnerLabel from "../../components/InputWithInnerLabel/InputWithInnerLabel";
import RadioBoxCollection from "../../components/RadioBoxCollection/RadioBoxCollection";
import LoaderOverlay from "../../components/LoaderOverlay/LoaderOverlay";
import CartCard from "../../components/CartCard/CartCard";
import FoloosiPayment from "../../components/FoloosiPayment/FoloosiPayment";
import Map from "../../components/Map/Map";

import { useTranslation } from "react-i18next";

const Checkout = () => {
  // global state
  const placeOrderBtn = useRef(null);
  const isCityFromSaved = useRef(false);
  const isAreaFromSaved = useRef(false);
  // Identifies the most recent shipping lookup so a slower, superseded run
  // can never overwrite fresher results.
  const shippingRequestId = useRef(0);
  const prevAddressRef = useRef({ postalCode: "", addressLine1: "" });
  const user = useSelector((state) => state.user.user);
  const productsIds = useSelector((state) => state.cart.products);
  const checkout = useSelector((state) => state.checkout);
  const discountRules = useSelector((state) => state.discountRules);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const location = useLocation();

  // personal info
  const [errorMessage, setErrorMessage] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [emailMe, setEmailMe] = useState(false);
  const [country, setCountry] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState(0);
  const [area, setArea] = useState(0);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const [canRedeem, setCanRedeem] = useState(false);
  const [isUsingPoints, setIsUsingPoints] = useState(false);
  const [pointsToRedeem, setPointsToRedeem] = useState(0);
  const [pointsTotal, setPointsTotal] = useState(0);
  const [userPoints, setUserPoints] = useState(0);
  const [redeemPointsPercentage, setRedeemPointsPercentage] = useState(0);
  const [minimumPoints, setMinimumPoints] = useState(0);
  const [pointsErrorMessage, setPointsErrorMessage] = useState("");

  const [addressesArr, setAddressesArr] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(0);
  const [areAddressesLoading, setAreAddressesLoading] = useState(false);
  const [areAddressesError, setAreAddressesError] = useState(false);
  const [addressesRetries, setAddressesRetries] = useState(0);

  const [turnMapOff, setTurnMapOff] = useState(false);
  const [AddressViaMap, setAddressViaMap] = useState({
    Country: 0,
    CountryName: "",
    City: 0,
    CityName: "",
    CityName2: "",
    Area: 0,
    AreaName: "",
    AreaName2: "",
    AddressLine1: "",
    AddressLine2: "",
    PostalCode: "",
    FirstName: "",
    LastName: "",
    MapLink: "",
    DisplayName: "",
    SelectedPosition: [],
  });
  const [cityViaMap, setCityViaMap] = useState("");
  const [city2ViaMap, setCity2ViaMap] = useState("");
  const [isCitySorted, setIsCitySorted] = useState(false);
  const [areaViaMap, setAreaViaMap] = useState("");
  const [area2ViaMap, setArea2ViaMap] = useState("");
  const [isAreaSorted, setIsAreaSorted] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [mapLink, setMapLink] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [selectedPosition, setSelectedPosition] = useState([
    25.276987, 55.296249,
  ]);

  const [phone, setPhone] = useState("");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);

  const [shippingProvidersArr, setShippingProvidersArr] = useState([]);
  const [shippingRatesArr, setShippingRatesArr] = useState([]);
  const [shipping, setShipping] = useState("");
  const [shippingProductCode, setShippingProductCode] = useState("");
  const [hasFreeShipping, setHasFreeShipping] = useState(false);

  const [deliveryNotes, setDeliveryNotes] = useState("");
  const [specialRequests, setSpecialRequests] = useState("");
  const [showGift, setShowGift] = useState(false);
  const [giftMessage, setGiftMessage] = useState("");

  const [paymentMethodsArr, setPaymentMethodsArr] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [additionalMethods, setAdditionalMethods] = useState(new Set([]));

  const [countriesArr, setCountriesArr] = useState([]);
  const [citiesArr, setCitiesArr] = useState([]);
  const [areasArr, setAreasArr] = useState([]);

  // products
  const [products, setProducts] = useState([]);
  const [areProductsLoading, setAreProductsLoading] = useState(false);
  const [areProductsError, setAreProductsError] = useState(false);
  const [productsRetries, setProductsRetries] = useState(0);

  const [promoValue, setPromoValue] = useState("");
  const [isPromoLoading, setIsPromoLoading] = useState(false);
  const [isPromoError, setIsPromoError] = useState(false);
  const [promoRetries, setPromoRetries] = useState(0);
  const [promoParams, setPromoParams] = useState(
    new URLSearchParams({
      populate: "*",
      "filters[Name][$eq]": "",
      try: promoRetries,
    })
  );
  const [showPromoMessage, setShowPromoMessage] = useState(false);
  const [promoMessage, setPromoMessage] = useState("");
  const [promoAmountToDeduct, setPromoAmountToDeduct] = useState(0);

  const [isVoucherLoading, setIsVoucherLoading] = useState(false);
  const [isVoucherError, setIsVoucherError] = useState(false);
  const [voucherRetries, setVoucherRetries] = useState(0);
  const [voucherParams, setVoucherParams] = useState(
    new URLSearchParams({
      populate: "*",
      "filters[Code][$eq]": "",
      try: voucherRetries,
    })
  );

  const [subtotal, setSubtotal] = useState(0);
  const [shippingValue, setShippingValue] = useState(0);
  const [total, setTotal] = useState(0);
  const [vat, setVat] = useState(0);

  // place order request state variables
  const [placeOrderData, setPlaceOrderData] = useState({});
  const [placeOrderLoading, setPlaceOrderLoading] = useState(false);
  const [placeOrderError, setPlaceOrderError] = useState(false);
  const [placeOrderRetries, setPlaceOrderRetries] = useState(0);
  const [requestData, setRequestData] = useState({});
  const [checkoutBtnDisabled, setCheckoutBtnDisabled] = useState(false);
  const [unavailableProducts, setUnavailableProducts] = useState([]);

  const [settings, setSettings] = useState([]);

  const [offers, setOffers] = useState([]);
  const [appliedOffer, setAppliedOffer] = useState({});
  const [offerTip, setOfferTip] = useState("");
  const [offeredProducts, setOfferedProducts] = useState([]);

  const [clearances, setClearances] = useState([]);

  const [fixedShipping, setFixedShipping] = useState(false);
  const [fixedShippingValue, setFixedShippingValue] = useState(0);
  const [fixedShippingArr, setFixedShippingArr] = useState([]);

  const [packages, setPackages] = useState([]);
  const [invoice, setInvoice] = useState("");

  // update order state variables
  const [updateOrderRequestData, setUpdateOrderRequestData] = useState({});
  const [updateOrderData, setUpdateOrderData] = useState({});
  const [updateOrderRetries, setUpdateOrderRetries] = useState(0);
  const [updateOrderLoading, setUpdateOrderLoading] = useState(false);
  const [updateOrderError, setUpdateOrderError] = useState(false);
  const [noRedirect, setNoRedirect] = useState(false);

  const updateOrderUrl = `/orders/${placeOrderData?.data?.id}`;
  const {
    data: UpdateOrderData,
    loading: UpdateOrderLoading,
    error: UpdateOrderError,
    status: UpdateOrderStatus,
    errorMessage: UpdateOrderErrorMessage,
  } = usePut(updateOrderUrl, updateOrderRequestData);

  const addressesUrl = buildAddressesUrl(user?.id, addressesRetries);
  const {
    data: addressesData,
    loading: addressesLoading,
    error: addressesError,
  } = useAddressesFetch(addressesUrl);

  const productsBaseUrl = "/products";
  const productsParams = new URLSearchParams({
    populate: "deep,4",
    locale: "en",
  });
  if (productsRetries > 0) productsParams.set("_retry", productsRetries);
  const uniqueProductIds = [...new Set(productsIds.map(p => p.id).filter(id => id != null))];
  uniqueProductIds.forEach((id, index) => {
    productsParams.append(`filters[id][$in][${index}]`, id);
  });

  const productsUrl = `${productsBaseUrl}?${productsParams.toString()}`;
  const {
    data: productsData,
    loading: productsLoading,
    error: productsError,
  } = useFetch(productsUrl);

  const promoBaseUrl = "/promo-codes";
  const promoUrl = `${promoBaseUrl}?${promoParams?.toString()}`;
  const {
    data: promoData,
    loading: promoLoading,
    error: promoError,
  } = useFetch(promoUrl);

  const voucherBaseUrl = "/vouchers";
  const voucherUrl = `${voucherBaseUrl}?${voucherParams?.toString()}`;
  const {
    data: voucherData,
    loading: voucherLoading,
    error: voucherError,
  } = useFetch(voucherUrl);

  // const addressesBaseUrl = "/addresses";
  // const addressesParams = new URLSearchParams({
  //   populate: "deep",
  //   "filters[User][id][$eq]": user?.id,
  //   sort: "updatedAt:desc",
  // });
  // if (addressesRetries > 0) addressesParams.set("_retry", addressesRetries);

  // const addressesUrl = `${addressesBaseUrl}?${addressesParams.toString()}`;
  // const {
  //   data: addressesData,
  //   loading: addressesLoading,
  //   error: addressesError,
  // } = useFetch(addressesUrl);



  const PlaceOrderUrl = "/orders";
  const {
    data: PlaceOrderData,
    loading: PlaceOrderLoading,
    error: PlaceOrderError,
    status: PlaceOrderStatus,
    errorMessage: PlaceOrderErrorMessage,
  } = usePost(PlaceOrderUrl, requestData);

  const {
    data: zonesData,
    loading: zonesLoading,
    error: zonesError,
    setError: setZonesError,
    retry: zonesRetryFunc,
  } = useZones();

  const {
    data: CityData,
    loading: CityLoading,
    error: CityError,
  } = useGetCity(country);

  const {
    data: AreaData,
    loading: AreaLoading,
    error: AreaError,
  } = useGetArea(city);

  const {
    addAddress,
    updateAddress,
    loading: AddressHookLoading,
    error: AddressHookError,
    setError: setAddressHookError,
    retry: AddressHookRetryFunc,
  } = useAddress();

  const {
    data: paymentMethodsData,
    loading: paymentMethodsLoading,
    error: paymentMethodsError,
    setError: setPaymentMethodsError,
    retry: paymentMethodsRetryFunc,
  } = usePaymentMethods();

  const {
    data: shippingProvidersData,
    loading: shippingProvidersLoading,
    error: shippingProvidersError,
    setError: setShippingProvidersError,
    retry: shippingProvidersRetryFunc,
  } = useShippingProviders();

  const {
    data: shippingRatesData,
    loading: shippingRatesLoading,
    error: shippingRatesError,
    setError: setShippingRatesError,
    retry: shippingRatesRetryFunc,
  } = useShippingRates();

  const {
    referenceToken: foloosiReferenceToken,
    loading: foloosiReferenceTokenLoading,
    error: foloosiReferenceTokenError,
    getReferenceToken,
  } = useFoloosiReferenceToken();

  const {
    paymentLink: NetworkPaymentLink,
    loading: NetworkLoading,
    error: NetworkError,
    initiatePayment,
  } = useNetworkPayment();

  const {
    getDHLSettings,
    createShipment,
    getRates: getDHLRates,
    loading: dhlLoading,
    error: dhlError,
    setError: setDhlError,
    retry: retryDHL,
  } = useDHLShipping();

  const {
    createSMSAShipment,
    loading: SMSALoading,
    error: SMSAError,
    setError: setSMSAError,
    retry: retrySMSA,
  } = useSMSAShipping();

  const {
    createNetGlobalShipment,
    loading: NetGlobalLoading,
    error: NetGlobalError,
    setError: setNetGlobalError,
    retry: retryNetGlobal,
  } = useNetGlobalShipping();

  const {
    getSiteSettings,
    data: siteSettingsData,
    loading: siteSettingsLoading,
    error: siteSettingsError,
    setError: siteSettingsSetError,
    retry: siteSettingsRetry,
  } = useSettings();

  const {
    getOffers,
    data: offersData,
    loading: offersLoading,
    error: offersError,
    setError: offersSetError,
    retry: offersRetry,
  } = useGetOffers();

  const {
    getClearances,
    data: clearancesData,
    loading: clearancesLoading,
    error: clearancesError,
    setError: clearancesSetError,
    retry: clearancesRetry,
  } = useGetClearances();

  const {
    getFixedShipping,
    data: fixedShippingData,
    loading: fixedShippingLoading,
    error: fixedShippingError,
    setError: fixedShippingSetError,
    retry: fixedShippingRetry,
  } = useGetFixedShipping();

  const retryProduct = () => setProductsRetries((prev) => prev + 1);
  const retryPromo = () => setPromoRetries((prev) => prev + 1);
  const retryVouchers = () => setVoucherRetries((prev) => prev + 1);
  const retryPlaceOrder = () => setPlaceOrderRetries((prev) => prev + 1);
  const retryUpdateOrder = () => setUpdateOrderRetries((prev) => prev + 1);
  const retryAddresses = () => setAddressesRetries((prev) => prev + 1);

  // handler functions
  // Maps each cart item (barcode + button) to its pre-offer price baseline
  // (the price after discount rules, before any offer stamping).
  const buildRuleBaselines = (prods) => {
    const map = {};
    prods?.forEach((p) => {
      map[`${p?.barcode}__${p?.selectedButtonId}`] =
        p?.product?.attributes?.discountedPrice ?? null;
    });
    return map;
  };

  // Returns true when at least one item's effective unit price differs
  // between the freshly recalculated products and what is currently shown.
  const hasStalePrices = (freshProds, shownProds) => {
    if (!freshProds?.length || !shownProds?.length) return false;
    const displayed = new Map(
      shownProds.map((p) => [
        `${p?.barcode}__${p?.selectedButtonId}`,
        parseFloat(
          p?.product?.attributes?.discountedPrice ??
          p?.product?.attributes?.Price
        ),
      ])
    );
    return freshProds.some((p) => {
      const key = `${p?.barcode}__${p?.selectedButtonId}`;
      if (!displayed.has(key)) return false;
      const freshPrice = parseFloat(
        p?.product?.attributes?.discountedPrice ?? p?.product?.attributes?.Price
      );
      return Math.abs(freshPrice - displayed.get(key)) > 0.01;
    });
  };

  const handleOffers = (products, offers, ruleBaselines = null) => {
    const { offer, tip, offerAppliedProducts } = applyOffers(products, offers);
    if (offer && offerAppliedProducts?.length > 0) {
      setAppliedOffer(offer);
      setOfferedProducts(offerAppliedProducts);
      setOfferTip("");
    } else if (!offer && tip) {
      setAppliedOffer({});
      setOfferedProducts([]);
      setOfferTip(tip);
    } else if (!offer && !tip) {
      setAppliedOffer({});
      setOfferedProducts([]);
      setOfferTip("");
    }

    if (offer && offerAppliedProducts?.length > 0 && products?.length > 0) {
      const offerDeductionValue = offer?.attributes?.DiscountValue;
      const offerDeductionType = offer?.attributes?.DiscountType;

      const newProducts = [];
      for (const product of products) {
        const offeredProduct = offerAppliedProducts?.find(
          (prod) => product?.barcode == prod?.barcode && product?.selectedButtonId === prod?.selectedButtonId
        );
        if (!offeredProduct) {
          const newProd = structuredClone(product);
          newProducts.push(newProd);
          continue;
        }
        let newProductDiscount = 0;
        const productPrice =
          product?.product?.attributes?.discountedPrice ??
          product?.product?.attributes?.Price;
        if (offerDeductionType == "Percentage") {
          newProductDiscount = productPrice * (offerDeductionValue / 100);
        } else {
          newProductDiscount = offerDeductionValue;
        }
        const newProd = structuredClone(product);
        if (newProd.qty > offeredProduct?.quantity) {
          const newestProd = structuredClone(newProd);
          newProd.qty = offeredProduct?.quantity;
          newestProd.qty -= offeredProduct?.quantity;
          newProducts.push(newestProd);
        }
        newProd.product.attributes.discountedPrice = parseFloat(
          (productPrice - newProductDiscount).toFixed(2)
        );
        newProducts.push(newProd);
      }
      return [newProducts, true];
    }
    // No valid offer applies: restore each item's discount-rule baseline so
    // any stale offer discount is stripped while rule discounts survive.
    if (ruleBaselines) {
      products.forEach((prod) => {
        const key = `${prod?.barcode}__${prod?.selectedButtonId}`;
        if (!(key in ruleBaselines)) return;
        const baseline = ruleBaselines[key];
        if (baseline == null) {
          prod.product.attributes.discountedPrice = null;
        } else {
          prod.product.attributes.discountedPrice = baseline;
        }
      });
    }
    return [products, false];
  };

  const handleClearances = (products, clearances) => {
    const results = applyClearances(products, clearances);

    if (results.length > 0) {
      const newClearanceProducts = [];
      for (const { clearance, clearanceProducts } of results) {
        const clearancePrice = clearance?.attributes?.Price;

        clearanceProducts.forEach((clearanceSet) => {
          const newSet = [];
          let setTotalPrice = 0;
          clearanceSet?.forEach((clearanceProd) => {
            setTotalPrice +=
              clearanceProd?.product?.product?.attributes?.discountedPrice ??
              clearanceProd?.product?.product?.attributes?.Price *
              clearanceProd?.quantity;
          });

          let discountPercentage = parseFloat(
            (1 - clearancePrice / setTotalPrice) * 100
          );

          clearanceSet?.forEach((clearanceProd) => {
            const isProdAlreadyAdded = newSet?.find(
              (cp) => cp?.barcode === clearanceProd?.barcode
            );
            if (isProdAlreadyAdded) {
              isProdAlreadyAdded.quantity += clearanceProd?.quantity;
            } else {
              const prodPrice =
                clearanceProd?.product?.product?.attributes?.discountedPrice ??
                clearanceProd?.product?.product?.attributes?.Price;

              newSet.push({
                productID: clearanceProd?.productID,
                barcode: clearanceProd?.barcode,
                quantity: clearanceProd?.quantity,
                newPrice: parseFloat(
                  (prodPrice - (prodPrice * discountPercentage) / 100).toFixed(
                    2
                  )
                ),
              });
            }
          });

          let setPrice = 0;
          newSet.forEach(
            (prod) => (setPrice += prod?.newPrice * prod?.quantity)
          );
          if (setPrice !== clearancePrice) {
            let fineTuned = false;
            let counter = 0;
            let quantityThreshold = 1;
            while (!fineTuned) {
              if (counter === newSet?.length - 1) {
                counter = 0;
                quantityThreshold += 1;
                continue;
              }

              if (newSet[counter]?.quantity === quantityThreshold) {
                let difference = clearancePrice - setPrice;
                newSet[0].newPrice = parseFloat(
                  (
                    parseFloat(newSet[0]?.newPrice) +
                    parseFloat(
                      parseFloat(difference.toFixed(2)) / quantityThreshold
                    )
                  ).toFixed(2)
                );
                fineTuned = true;
              }
            }
          }
          newClearanceProducts.push(...newSet);
        });
      }

      // merging the same products
      const mergedProducts = [];
      for (const prod of newClearanceProducts) {
        const isProdAlreadyAdded = mergedProducts?.find(
          (cp) =>
            cp?.barcode === prod?.barcode && cp?.newPrice === prod?.newPrice
        );
        if (isProdAlreadyAdded) isProdAlreadyAdded.quantity += prod?.quantity;
        else mergedProducts.push(prod);
      }

      const newProducts = [];
      const expandedProducts = products.flatMap((item) =>
        Array.from({ length: item.qty }, () => ({
          ...item,
          qty: 1,
        }))
      );
      for (const product of expandedProducts) {
        const offeredProduct = mergedProducts?.find(
          (prod) =>
            product?.barcode == prod?.barcode && parseFloat(prod?.quantity) > 0
        );
        if (!offeredProduct) {
          const newProd = structuredClone(product);
          newProducts.push(newProd);
          continue;
        }

        const newProd = structuredClone(product);
        newProd.product.attributes.discountedPrice = parseFloat(
          offeredProduct?.newPrice
        );
        offeredProduct.quantity -= 1;
        newProducts.push(newProd);
      }

      const finalProducts = [];
      for (const product of newProducts) {
        const isProdAlreadyAdded = finalProducts?.find(
          (cp) =>
            cp?.barcode === product?.barcode &&
            cp?.product?.attributes?.Price ===
            product?.product?.attributes?.Price &&
            cp?.product?.attributes?.discountedPrice ===
            product?.product?.attributes?.discountedPrice
        );
        if (isProdAlreadyAdded) isProdAlreadyAdded.qty += product?.qty;
        else finalProducts.push(JSON.parse(JSON.stringify(product)));
      }
      return [finalProducts, true];
    }

    return [products, false];
  };

  const processProducts = () => {
    const unavailableList = [];
    const newProducts = [];

    productsIds.forEach((localProduct) => {
      const product = productsData?.find(
        (product) => product.id === localProduct.id
      );
      if (!product) {
        // Product is no longer returned by the (published) API, i.e. it was
        // unpublished/removed in Strapi.
        unavailableList.push(localProduct);
        return;
      }
      const newProduct = structuredClone(product);
      const discountedProduct = applyDiscountRules(
        [newProduct],
        discountRules,
        localProduct.selectedVariantId,
        localProduct.barcode,
        country
      );
      newProducts.push({
        product: discountedProduct[0],
        barcode: localProduct.barcode,
        selectedVariantId: localProduct.selectedVariantId,
        selectedButtonId: localProduct.selectedButtonId,
        qty: localProduct.quantity,
      });
    });

    // Only report unavailable items once the cart products have loaded, so we
    // never flag everything while productsData is still null/loading.
    if (productsData) {
      setUnavailableProducts(unavailableList);
    }

    // Check offers
    const [afterOffers, isOfferApplied] = handleOffers(newProducts, offers);
    const [afterClearances, isClearanceApplied] = handleClearances(
      newProducts,
      clearances
    );

    if (isClearanceApplied) return afterClearances;
    if (isOfferApplied && !isClearanceApplied) return afterOffers;

    return newProducts;
  };

  const processTotals = () => {
    if (productsIds?.length === 0) {
      dispatch(disableIsPromoApplied());
      dispatch(removePromo());
      setPromoValue("");
      setShowPromoMessage(false);
      setPromoRetries(0);
      setPromoMessage("");
      return;
    }

    const totals = calculateOrderTotals({
      products,
      country,
      shippingValue,
      hasFreeShipping,
      fixedShipping,
      fixedShippingValue,
      promo: checkout?.promo,
      isPromoApplied: checkout?.isPromoApplied,
      isVoucher: checkout?.isVoucher,
      pointsTotal,
    });

    if (checkout?.isPromoApplied) {
      setPromoValue(checkout?.promo?.attributes?.Name);
      if (checkout?.isVoucher) {
        setAdditionalMethods((prev) => prev.add("Voucher"));
      }
    }

    if (parseFloat(pointsTotal) > 0 && totals.total > 0) {
      setAdditionalMethods((prev) => prev.add("Points"));
    }

    setShippingValue(totals.shippingValue);
    setPromoAmountToDeduct(totals.amountToDeduct);
    setSubtotal(totals.subtotal.toFixed(2));
    setVat(totals.vat.toFixed(2));
    setTotal(totals.total.toFixed(2));
  };

  const submitPromo = (event) => {
    event.preventDefault();
    if (promoValue.trim() === "") return;
    const newPromoParams = new URLSearchParams(promoParams);
    newPromoParams.set("filters[Name][$eq]", promoValue);
    setPromoParams(newPromoParams);
  };

  const applyPromo = async (promo, isVoucher) => {
    if (
      promo?.length === 0 &&
      promoParams.get("filters[Name][$eq]") === "" &&
      voucherParams.get("filters[Code][$eq]") === ""
    ) {
      return;
    }

    if (
      promo?.length === 0 &&
      promoParams.get("filters[Name][$eq]") !== "" &&
      !isVoucher
    ) {
      const newVoucherParams = new URLSearchParams(voucherParams);
      newVoucherParams.set("filters[Code][$eq]", promoValue);
      setVoucherParams(newVoucherParams);
      return;
    }

    if (
      promo?.length === 0 &&
      voucherParams.get("filters[Code][$eq]") !== "" &&
      isVoucher
    ) {
      setShowPromoMessage(true);
      setPromoMessage(t("errors.promo-not-exist"));
      return;
    }

    // if (isVoucher && user?.id !== promo[0]?.attributes?.User?.data?.id) {
    //   setShowPromoMessage(true);
    //   setPromoMessage(t("errors.promo-not-exist"));
    //   return;
    // }

    const isValid = await isPromoValid(user, promo[0], isVoucher);
    if (!isValid) {
      setShowPromoMessage(true);
      setPromoMessage(t("errors.promo-not-exist"));
      return;
    }
    setShowPromoMessage(false);

    dispatch(enableIsPromoApplied());
    dispatch(addPromo(promo[0]));
    if (isVoucher) {
      dispatch(enableIsVoucher());
    } else {
      dispatch(disableIsVoucher());
    }
  };

  // UPDATE 09 MARCH, 2026
  const handlePayment = (orderId, orderTotal) => {
    const amountToPay = orderTotal != null ? orderTotal : total;
    if (parseFloat(amountToPay) == 0) {
      updatePaymentResponse({}, true);
    } else if (paymentMethod === "Foloosi") {
      const merchantKey = process.env.REACT_APP_FOLOOSI_MERCHANT_KEY;
      const payload = {
        transaction_amount: amountToPay,
        currency: "AED",
        customer_name: `${firstName} ${lastName}`,
        customer_email: registerEmail,
        customer_mobile: phone, checkout
      };
      getReferenceToken(merchantKey, payload);
    } else if (paymentMethod === "Network International") {
      const finalOrderId = orderId;

      console.log("--- Payment Initiation Details ---");
      console.log("Order ID (New Order):", finalOrderId);
      console.log("Amount:", amountToPay);
      console.log("----- ----- ----- ----- ----- -----");

      initiatePayment("AED", amountToPay, registerEmail, finalOrderId);
    } else {
      updatePaymentResponse({}, true);
    }
  };

  // UPDATE 26 FEB, 2026
  const submitOrder = async () => {
    try {
      const cityCheck = city
        ? await makeRequest.get(
          `/cities?locale=en&filters[id][$eq]=${city}&filters[Country][id][$eq]=${country}&pagination[limit]=1`
        )
        : null;
      if (!cityCheck?.data?.data?.length) {
        setErrorMessage(t("checkout.location-unavailable"));
        setCheckoutBtnDisabled(false);
        setTimeout(() => setErrorMessage(""), 8000);
        return;
      }
    } catch (e) {
      console.error("City re-check failed:", e);
    }
    dispatch(removeOrderID());
    dispatch(removeShippingData());
    let User = user?.id;
    let UserObject = user;
    let Email = registerEmail;
    let FirstName = firstName;
    let LastName = lastName;
    let Address1 = addressLine1;
    let Address2 = addressLine2;
    let PostalCode = postalCode;
    let PaymentMethod = [paymentMethod, ...additionalMethods].join(" - ");
    // TODO: payment method should do only voucher when the voucher covers the total
    let ShippingMethod = shipping;
    let PaymentResponse = "";
    let TotalBeforVAT = `${(total - vat).toFixed(2)}`;
    let TotalAfterVAT = total;
    let Status = "";
    let Phone = phone;
    let ShippingCost = shippingValue.toFixed(2);
    let IsGift = showGift;
    let GiftMessage = giftMessage;
    let Notes = deliveryNotes;
    let SpecialRequest = specialRequests;
    let VoucherCode = "";
    let CouponCode = "";
    let DicountAmount = 0;
    let Packages = [];
    let AddressDisplayName = displayName;
    let AddressMapLink = mapLink;
    // PERF: start independent requests now so they run in parallel
    const prefetchTs = Date.now();
    const rulesPromise = makeRequest.get(
      `/discount-rules?${new URLSearchParams({
        populate: "deep",
        "filters[Status][$eq]": true,
        _: prefetchTs,
      }).toString()}`
    );
    const offersPromise = makeRequest.get(
      `/offers?${new URLSearchParams({
        populate: "*",
        "pagination[limit]": -1,
        "filters[Status][$eq]": true,
        _: prefetchTs,
      }).toString()}`
    );
    const providersPromise = getFreshActiveShippingProviders();
    const ratesPromise =
      shipping && shipping !== "DHL" ? fetchFreshShippingRates() : null;
    const quantitiesPromise = getProductsQuantities(
      new Set(products?.map((prod) => prod?.product?.id))
    );
    const earlyAddress = addressesArr?.find(
      (address) => address?.id == selectedAddress
    );
    const defaultAddressPromise =
      Object.keys(user)?.length > 0 && earlyAddress
        ? updateAddress({ IsDefault: true }, earlyAddress?.id, user?.id)
        : null;
    [
      rulesPromise,
      offersPromise,
      providersPromise,
      ratesPromise,
      quantitiesPromise,
      defaultAddressPromise,
    ].forEach((p) => p?.catch?.(() => { }));
    // Re-fetch fresh products from Strapi to ensure latest prices before placing order
    let freshProcessedProducts = null;
    let freshRecalc = null;
    let freshHasFreeShipping = hasFreeShipping;
    // Live rate for the selected provider, re-resolved at submit time. null
    // means it was not verified (DHL, or the refresh failed).
    let freshShippingRate = null;
    try {
      const freshParams = new URLSearchParams({
        populate: "deep,4",
        locale: "en",
        // cache-bust so the freshest prices are always fetched even if the
        // production HTTP/CDN layer cached an earlier response
        _: Date.now(),
      });
      const uniqueIds = [...new Set(productsIds.map(p => p.id).filter(id => id != null))];
      uniqueIds.forEach((id, index) => {
        freshParams.append(`filters[id][$in][${index}]`, id);
      });
      const freshUrl = `${productsBaseUrl}?${freshParams.toString()}`;
      const freshRes = await makeRequest.get(freshUrl);
      const freshData = freshRes?.data?.data;

      // Block ordering if any cart product can no longer be fetched, i.e. it
      // was unpublished/removed in Strapi after being added to the cart.
      const missingCartProducts = productsIds.filter(
        (localProduct) =>
          !freshData?.some((p) => p.id === localProduct.id)
      );
      if (missingCartProducts.length > 0) {
        const missingBarcodes = missingCartProducts
          .map((p) => p?.barcode)
          .filter(Boolean)
          .join(", ");
        setErrorMessage(
          `${t("checkout.product-unavailable")}${missingBarcodes
            ? ` ${t("home.barcode")}: ${missingBarcodes}`
            : ""
          }`
        );
        setCheckoutBtnDisabled(false);
        return;
      }

      if (freshData?.length > 0) {
        // Re-fetch active discount rules so a rule disabled/expired after this
        // page loaded can no longer be applied to the order (item discounts
        // and free shipping both). On refetch failure we default to an EMPTY
        // rule set (never stale cached rules) so a disabled rule cannot be
        // re-applied to the order; the order still goes through.
        let effectiveDiscountRules = {
          isLoading: false,
          isError: false,
          rules: [],
        };
        try {
          const rulesRes = await rulesPromise;
          // const rulesParams = new URLSearchParams({
          //   populate: "deep",
          //   "filters[Status][$eq]": true,
          //   // cache-bust so a rule toggled in the admin (e.g. free shipping)
          //   // is applied even if the HTTP/CDN layer cached an older response
          //   _: Date.now(),
          // });
          // const rulesRes = await makeRequest.get(
          //   `/discount-rules?${rulesParams.toString()}`
          // );
          if (Array.isArray(rulesRes?.data?.data)) {
            effectiveDiscountRules = {
              isLoading: false,
              isError: false,
              rules: rulesRes.data.data,
            };
            dispatch(setDiscountRules(rulesRes.data.data));
          }
        } catch (e) {
          console.error("Failed to refresh discount rules:", e);
        }

        const newProds = productsIds.map((localProduct) => {
          const product = freshData.find((p) => p.id === localProduct.id);
          if (!product) return null;
          const newProduct = structuredClone(product);
          const discountedProduct = applyDiscountRules(
            [newProduct], effectiveDiscountRules,
            localProduct.selectedVariantId, localProduct.barcode, country
          );
          return {
            product: discountedProduct[0],
            barcode: localProduct.barcode,
            selectedVariantId: localProduct.selectedVariantId,
            selectedButtonId: localProduct.selectedButtonId,
            qty: localProduct.quantity,
          };
        }).filter(Boolean);

        // Re-fetch active offers so an offer that was disabled/expired after
        // this page loaded can no longer be applied to the order.
        let effectiveOffers = offers;
        try {
          const offersRes = await offersPromise;
          // const offersParams = new URLSearchParams({
          //   populate: "*",
          //   "pagination[limit]": -1,
          //   "filters[Status][$eq]": true,
          //   // cache-bust so an offer disabled/expired after page load is not
          //   // applied even if the HTTP/CDN layer cached an older response
          //   _: Date.now(),
          // });
          // const offersRes = await makeRequest.get(
          //   `/offers?${offersParams.toString()}`
          // );
          if (Array.isArray(offersRes?.data?.data)) {
            effectiveOffers = offersRes.data.data;
            setOffers(effectiveOffers);
          }
        } catch (e) {
          console.error("Failed to refresh offers:", e);
        }

        const ruleBaselines = buildRuleBaselines(newProds);
        const [afterOffers, isOfferApplied] = handleOffers(newProds, effectiveOffers, ruleBaselines);
        const [afterClearances, isClearanceApplied] = handleClearances(newProds, clearances);

        let finalProds;
        if (isClearanceApplied) finalProds = afterClearances;
        else if (isOfferApplied && !isClearanceApplied) finalProds = afterOffers;
        else finalProds = newProds;

        freshProcessedProducts = finalProds;
        setProducts(finalProds);

        // Re-validate the selected shipping provider against live Strapi
        // data: a provider stopped or deleted in the admin, or whose rate no
        // longer resolves for this destination/weight while the page was
        // open, cannot be used. The selection is cleared and the list rebuilt
        // from the active providers so the customer can pick another method.
        if (!shipping) {
          setShipping("");
          setShippingValue(0);
          setErrorMessage(t("checkout.shipping-method-unavailable"));
          setCheckoutBtnDisabled(false);
          setTimeout(() => setErrorMessage(""), 8000);
          return;
        }

        try {
          // const activeProviderNames = await getFreshActiveShippingProviders();
          const activeProviderNames = await providersPromise;

          if (activeProviderNames && !activeProviderNames.has(shipping)) {
            setShipping("");
            setShippingValue(0);
            updateShippingArray(finalProds, activeProviderNames);
            setErrorMessage(t("checkout.shipping-method-unavailable"));
            setCheckoutBtnDisabled(false);
            setTimeout(() => setErrorMessage(""), 8000);
            return;
          }

          // DHL is priced live by the carrier, so the active-provider check
          // above is the whole availability test: the rate is intentionally
          // not re-requested, since a carrier outage must not end the order.
          if (shipping !== "DHL") {
            const { rate: resolvedRate, rates: freshRates } =
              await getFreshStaticShippingRate({
                shippingMethod: shipping,
                country,
                city,
                area,
                products: finalProds,
                activeProviderNames,
                ratesPromise,
              });

            if (resolvedRate > 0) {
              // Fee edited in the admin while the page was open: reprice
              // silently instead of blocking the order.
              freshShippingRate = resolvedRate;
            } else if (resolvedRate === 0 && activeProviderNames) {
              // Verifiably no longer offered. resolvedRate === null means the
              // rate list could not be fetched, which must fail open.
              setShippingRatesArr(freshRates);
              setShipping("");
              setShippingValue(0);
              updateShippingArray(finalProds, activeProviderNames, freshRates);
              setErrorMessage(t("checkout.shipping-method-unavailable"));
              setCheckoutBtnDisabled(false);
              setTimeout(() => setErrorMessage(""), 8000);
              return;
            }
          }
        } catch (e) {
          // Never block an order on a transient refresh failure: fall back to
          // the rate already shown. The zero-cost guard below still applies.
          console.error("Failed to refresh shipping method:", e);
        }

        // Recompute free shipping from the freshly fetched cart (not the
        // possibly stale hasFreeShipping/subtotal state) so the stored total
        // always includes the correct shipping amount at submit time.
        const freshGrossSubtotal = finalProds?.reduce((sum, prod) => {
          const price =
            prod?.product?.attributes?.discountedPrice ??
            prod?.product?.attributes?.Price;
          return sum + (parseFloat(price) || 0) * (parseFloat(prod?.qty) || 1);
        }, 0);

        freshHasFreeShipping = calculateFreeShipping(
          finalProds,
          effectiveDiscountRules,
          freshGrossSubtotal,
          shipping,
          country
        );

        const recalc = calculateOrderTotals({
          products: finalProds,
          country,
          shippingValue: freshHasFreeShipping
            ? 0
            : (freshShippingRate ?? shippingValue),
          hasFreeShipping: freshHasFreeShipping,
          fixedShipping: freshHasFreeShipping ? false : fixedShipping,
          fixedShippingValue,
          promo: checkout?.promo,
          isPromoApplied: checkout?.isPromoApplied,
          isVoucher: checkout?.isVoucher,
          pointsTotal,
        });
        freshRecalc = recalc;

        // If freshly recalculated prices differ from what the customer sees
        // (e.g. an offer ended while the page was open), update the UI and
        // block this submission so the order never uses stale offer pricing.
        if (hasStalePrices(finalProds, products)) {
          setSubtotal(recalc.subtotal.toFixed(2));
          setVat(recalc.vat.toFixed(2));
          setTotal(recalc.total.toFixed(2));
          setPromoAmountToDeduct(recalc.amountToDeduct);
          setErrorMessage(t("checkout.offer-no-longer-valid"));
          setCheckoutBtnDisabled(false);
          return;
        }

        setSubtotal(recalc.subtotal.toFixed(2));
        setVat(recalc.vat.toFixed(2));
        setTotal(recalc.total.toFixed(2));
      }
    } catch (e) {
      console.error("Failed to refresh product prices:", e);
    }

    // Use the fresh calculation for the stored order, falling back to current
    // state only if the price refresh failed.
    const effectiveHasFreeShipping = freshRecalc
      ? freshHasFreeShipping
      : hasFreeShipping;
    const effectiveShippingValue = freshRecalc
      ? freshRecalc.shippingValue
      : (freshShippingRate ?? shippingValue);

    // The stored shipping value must reflect the real rate even when the order
    // qualifies for free shipping. When free shipping applies the effective
    // value is 0 (the customer is not charged), so fall back to the selected
    // provider's rate to keep the real amount in the order record.
    let realShippingValue = effectiveShippingValue;
    if (effectiveHasFreeShipping) {
      realShippingValue =
        parseFloat(effectiveShippingValue) > 0
          ? effectiveShippingValue
          : (freshShippingRate ??
            shippingProvidersArr?.find((p) => p?.Name === shipping)?.Value) ||
          0;
    }

    if (freshRecalc) {
      TotalBeforVAT = `${(freshRecalc.total - freshRecalc.vat).toFixed(2)}`;
      TotalAfterVAT = freshRecalc.total.toFixed(2);
    }
    ShippingCost = realShippingValue.toFixed(2);

    // Safety guard: prevent storing a 0 shipping cost
    if (parseFloat(ShippingCost) === 0) {
      setCheckoutBtnDisabled(false);
      setErrorMessage(
        "Shipping cost could not be calculated. Please select a shipping method and try again."
      );
      return;
    }

    // const productsQtyIds = products?.map((prod) => prod?.product?.id);
    // const filteredIds = new Set(productsQtyIds);
    // const quantities = await getProductsQuantities(filteredIds);
    const quantities = await quantitiesPromise;


    let QtyError = "";
    for (const product of products) {
      for (const qty of quantities) {
        if (product?.product?.id !== qty?.id) continue;

        for (const variant of qty?.attributes?.Variants || []) {
          let sizeFound = false;
          for (const size of variant?.Sizes || []) {
            if (product?.barcode !== size?.Barcode) continue;

            if (parseFloat(size?.Quantity) < parseFloat(product?.qty)) {
              QtyError = `${product?.product?.attributes?.Title} ${t(
                "checkout.with-barcode"
              )} ${product?.barcode} ${t("checkout.has-only")} ${size?.Quantity
                } ${t("checkout.pieces-left")}.`;
            }
            sizeFound = true;
            break;
          }
          if (sizeFound) break;
        }
        break;
      }
      if (QtyError?.trim() !== "") break;
    }

    if (QtyError?.trim() !== "") {
      setErrorMessage(QtyError);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      setCheckoutBtnDisabled(false);
      return;
    }

    if (country != 231) {
      const totalToUse = freshRecalc ? freshRecalc.total.toFixed(2) : total;
      TotalBeforVAT = totalToUse;
      TotalAfterVAT = totalToUse;
    }

    const Address = addressesArr?.find(
      (address) => address?.id == selectedAddress
    );

    // if (Object.keys(user)?.length > 0 && Address) {
    //   const newAddress = {
    //     IsDefault: true,
    //   };
    //   await updateAddress(newAddress, Address?.id, user?.id);
    // }
    if (defaultAddressPromise) {
      await defaultAddressPromise;
    }

    if (paymentMethod == "Cash On Delivery") {
      Status = "Open";
    } else {
      Status = "Draft";
    }

    let numOfPackages = 1;
    let weight = 0;
    //siham
    // const maxPackageWeight = parseFloat(
    //   settings?.find(
    //     (setting) =>
    //       setting?.attributes?.SettingName === "DHL Max Package Weight"
    //   )?.attributes?.SettingValue
    // );
    const fetchedMaxWeight = parseFloat(
      settings?.find(
        (setting) =>
          setting?.attributes?.SettingName === "DHL Max Package Weight"
      )?.attributes?.SettingValue
    );
    const maxPackageWeight = isNaN(fetchedMaxWeight) ? 20 : fetchedMaxWeight;

    let remainingProducts = products.map((product) => {
      return {
        ...product,
        remainingQty: product?.qty,
      };
    });

    while (remainingProducts.length > 0) {
      const currentPackage = {
        Number: generatePackageID(numOfPackages),
        Products: [],
        Weight: 0,
      };

      let addedToPackage = false;

      for (let i = 0; i < remainingProducts.length;) {
        const product = remainingProducts[i];
        const productWeight = parseFloat(calculateWeight([product], false));
        const [color, size] = getColorAndSize(
          product?.product,
          product?.barcode,
          product?.selectedVariantId
        );
        const remainingWeight = maxPackageWeight - weight;

        if (remainingWeight >= productWeight && product.remainingQty > 0) {
          const unitsThatFit = Math.min(
            Math.floor(remainingWeight / productWeight) || 0,
            product.remainingQty
          );
          if (unitsThatFit > 0) {
            const isProdAlreadyAdded = currentPackage?.Products?.find(
              (prod) => prod?.Barcode === product?.barcode
            );
            if (isProdAlreadyAdded) {
              isProdAlreadyAdded.Quantity += unitsThatFit;
            } else {
              currentPackage.Products.push({
                ProductName: product?.product?.attributes?.Title,
                Quantity: unitsThatFit,
                Barcode: product?.barcode,
                Color: color,
                Size: size,
                Prod: product?.product,
              });
            }

            weight += unitsThatFit * productWeight;
            currentPackage.Weight = parseFloat(weight.toFixed(2));
            product.remainingQty -= unitsThatFit;
            addedToPackage = true;

            if (product.remainingQty === 0) {
              remainingProducts.splice(i, 1);
            } else {
              i++;
            }
          } else {
            i++;
          }
        } else {
          i++;
        }
      }
      //siham
      // if (!addedToPackage) {
      //   console.error(
      //     "Cannot fit any remaining products in the package. Check maxPackageWeight or product data."
      //   );
      //   break;
      // }
      if (!addedToPackage) {
        console.error(
          "Cannot fit any remaining products in the package. Check maxPackageWeight or product data."
        );
        if (remainingProducts.length > 0) {
          const product = remainingProducts[0];
          const [color, size] = getColorAndSize(
            product?.product,
            product?.barcode,
            product?.selectedVariantId
          );
          currentPackage.Products.push({
            ProductName: product?.product?.attributes?.Title,
            Quantity: product.remainingQty,
            Barcode: product?.barcode,
            Color: color,
            Size: size,
            Prod: product?.product,
          });
          currentPackage.Weight = parseFloat((parseFloat(calculateWeight([product], false)) || 0.5).toFixed(2));
          remainingProducts.splice(0, 1);
        }
      }

      Packages.push(currentPackage);
      numOfPackages++;
      weight = 0;
    }

    setPackages(
      Packages?.map((pkg) => {
        return {
          PackageNumber: pkg?.Number,
          Products: pkg?.Products,
          Weight: pkg?.Weight,
        };
      })
    );

    let City = citiesArr?.find((cityObj) => cityObj?.id == city)?.Name;
    let Country = countriesArr?.find(
      (countObj) => countObj?.id == country
    )?.Name;
    let Area = areasArr?.find((areaObj) => areaObj?.id == (Address?.Area || area))?.Name;

    if (!Country || !City || (area && !Area)) {
      setErrorMessage("Please wait for address data to finish loading.");
      setCheckoutBtnDisabled(false);
      return;
    }

    if (emailMe) {
      const result = await subscribeToNewsletter(registerEmail);
    }

    if (Object.keys(user)?.length === 0) {
      setPlaceOrderLoading(true);
      const { error, data } = await generateUser(
        registerEmail,
        firstName,
        lastName,
        phone
      );
      setPlaceOrderLoading(false);

      if (error) {
        navigate("/login?to=checkout");
        return;
      }

      dispatch(
        setUser({
          jwt: data?.jwt,
          user: data?.user,
        })
      );

      User = data?.user?.id;
      UserObject = data?.user;

      const newAddress = {
        User: data?.user?.id,
        FirstName: firstName,
        LastName: lastName,
        Address1: addressLine1,
        Address2: addressLine2,
        Postcode: postalCode,
        IsDefault: true,
        Country: country,
        City: city,
        Area: null,
      };

      if (area) newAddress.Area = area;
      if (mapLink?.trim() !== "") newAddress.MapLink = mapLink;
      if (displayName?.trim() !== "") newAddress.DisplayName = displayName;

      await addAddress(newAddress, data?.user?.id);
    }

    let freshPromo = null;
    if (checkout?.isPromoApplied) {
      freshPromo = await getFreshPromo(
        UserObject,
        checkout?.promo,
        checkout?.isVoucher
      );

      if (!freshPromo) {
        dispatch(disableIsPromoApplied());
        dispatch(disableIsVoucher());
        dispatch(removePromo());

        const recalculated = calculateOrderTotals({
          products: freshProcessedProducts || products,
          country,
          shippingValue: effectiveShippingValue,
          hasFreeShipping: effectiveHasFreeShipping,
          fixedShipping: effectiveHasFreeShipping ? false : fixedShipping,
          fixedShippingValue,
          promo: null,
          isPromoApplied: false,
          isVoucher: false,
          pointsTotal,
        });

        const correctedTotal = recalculated.total.toFixed(2);
        TotalBeforVAT = country !== 231
          ? correctedTotal
          : (recalculated.total - recalculated.vat).toFixed(2);
        TotalAfterVAT = correctedTotal;

        setTotal(correctedTotal);
        setSubtotal(recalculated.subtotal.toFixed(2));
        setVat(recalculated.vat.toFixed(2));
        setPromoAmountToDeduct(0);

        setShowPromoMessage(true);
        setPromoMessage(t("errors.promo-not-exist"));
      } else {
        // The promo/voucher was just re-fetched from the API: recalculate the
        // deduction from its CURRENT Amount/Type so an admin-side change to
        // the discount value is honored instead of the cached cart value.
        if (freshRecalc && freshProcessedProducts) {
          freshRecalc = calculateOrderTotals({
            products: freshProcessedProducts,
            country,
            shippingValue: freshHasFreeShipping
              ? 0
              : (freshShippingRate ?? shippingValue),
            hasFreeShipping: freshHasFreeShipping,
            fixedShipping: freshHasFreeShipping ? false : fixedShipping,
            fixedShippingValue,
            promo: freshPromo,
            isPromoApplied: true,
            isVoucher: checkout?.isVoucher,
            pointsTotal,
          });
          TotalBeforVAT = `${(freshRecalc.total - freshRecalc.vat).toFixed(2)}`;
          TotalAfterVAT = freshRecalc.total.toFixed(2);
          setSubtotal(freshRecalc.subtotal.toFixed(2));
          setVat(freshRecalc.vat.toFixed(2));
          setTotal(freshRecalc.total.toFixed(2));
        }
        DicountAmount = freshRecalc ? freshRecalc.amountToDeduct : parseFloat(promoAmountToDeduct);
        if (checkout?.isVoucher) {
          VoucherCode = checkout?.promo?.attributes?.Code;
          dispatch(setVoucherAmount(DicountAmount));
          const effectiveTotal = freshRecalc ? freshRecalc.total : total;
          if (effectiveTotal > 0) {
            if (TotalBeforVAT < 0) TotalBeforVAT = `0`;
            if (TotalAfterVAT < 0) TotalAfterVAT = `0`;
          } else {
            TotalBeforVAT = `0`;
            TotalAfterVAT = `0`;
          }
        } else {
          CouponCode = checkout?.promo?.attributes?.Name;
        }
      }
    }

    let productsArr = [];
    let totalProductsDiscounts = 0;
    let productsPricesBeforeDiscount = 0;
    let productsVATs = 0;

    const orderProducts = freshProcessedProducts || products;

    let promoDiscount = parseFloat(DicountAmount) || 0;
    let totalProductsPriceForPromo = 0;
    orderProducts?.forEach((prod) => {
      let pp = prod?.product?.attributes?.Price;
      let effectiveP = prod?.product?.attributes?.discountedPrice != null
        ? prod?.product?.attributes?.discountedPrice : pp;
      totalProductsPriceForPromo += effectiveP * prod?.qty;
    });

    orderProducts?.forEach((prod) => {
      const [color, size] = getColorAndSize(
        prod?.product,
        prod?.barcode,
        prod?.selectedVariantId
      );
      const button = getButton(prod?.product, prod?.selectedButtonId, prod?.selectedVariantId);
      let prodPrice = prod?.product?.attributes?.Price;
      productsPricesBeforeDiscount += prodPrice * prod?.qty;
      let prodPriceWithoutVAT = parseFloat((prodPrice / 1.05).toFixed(2));
      let vatAmount = prodPrice - prodPriceWithoutVAT;
      productsVATs += vatAmount * prod?.qty;
      let discountAmount = 0;
      let grossAmount = prodPrice;
      if (prod?.product?.attributes?.discountedPrice != null) {
        discountAmount =
          (prodPrice - prod?.product?.attributes?.discountedPrice) * prod?.qty;
        totalProductsDiscounts += discountAmount;
        grossAmount = prod?.product?.attributes?.discountedPrice;
      }
      let promoShare = 0;
      if (promoDiscount > 0 && totalProductsPriceForPromo > 0) {
        promoShare = parseFloat((promoDiscount * (grossAmount * prod?.qty / totalProductsPriceForPromo)).toFixed(2));
      }
      productsArr.push({
        ProductName: prod?.product?.attributes?.Title,
        PriceBeforeVAT: country != 231 ? prodPrice : prodPriceWithoutVAT,
        PriceAfterVAT: prodPrice,
        Quantity: prod?.qty,
        Product: prod?.product?.id,
        Barcode: prod?.barcode,
        Size: size,
        Color: color,
        Button: button,
        DiscountAmount: discountAmount + promoShare,
        VAT: country != 231 ? "0.00" : parseFloat(vatAmount.toFixed(2)),
        GrossAmount: grossAmount * prod?.qty - promoShare,
        Weight: parseFloat(calculateWeight([prod], false)),
        Image: prod?.product?.attributes?.DefaultImage?.data?.id,
      });
    });

    DicountAmount =
      parseFloat(DicountAmount) + parseFloat(totalProductsDiscounts);

    let totalsArr = [];
    //siham
    // if (country != 231) {
    //   productsVATs = 0;
    // }
    let currentProductsVATs = productsVATs;
    if (country != 231) {
      currentProductsVATs = 0;
    }


    totalsArr.push({
      TotalName: "Net Amount",
      TotalValue: (
        parseFloat(productsPricesBeforeDiscount) - parseFloat(productsVATs)
      ).toFixed(2),
    });
    //siham
    // totalsArr.push({
    //   TotalName: "VAT",
    //   TotalValue: parseFloat(productsVATs)?.toFixed(2),
    // });
    totalsArr.push({
      TotalName: "VAT",
      TotalValue: parseFloat(currentProductsVATs)?.toFixed(2),
    });
    totalsArr.push({
      TotalName: "Subtotal",
      TotalValue: parseFloat(productsPricesBeforeDiscount).toFixed(2),
    });
    totalsArr.push({
      TotalName: "Shipping",
      TotalValue: realShippingValue.toFixed(2),
    });
    if (totalProductsDiscounts > 0) {
      totalsArr.push({
        TotalName: "Discount",
        TotalValue: totalProductsDiscounts.toFixed(2),
      });
    }
    if (effectiveHasFreeShipping) {
      totalsArr.push({
        TotalName: `Discount - Free Shipping`,
        TotalValue: realShippingValue.toFixed(2),
      });
    }
    if (checkout?.isPromoApplied && freshPromo) {
      totalsArr.push({
        TotalName: `${checkout?.isVoucher ? "Voucher" : "Promo"} - ${checkout?.isVoucher
          ? checkout?.promo?.attributes?.Code
          : checkout?.promo?.attributes?.Name
          }`,
        TotalValue: freshRecalc ? freshRecalc.amountToDeduct : promoAmountToDeduct,
      });
    }
    if (parseFloat(pointsTotal) > 0) {
      totalsArr.push({
        TotalName: `Redeemed Points`,
        TotalValue: parseFloat(pointsTotal).toFixed(2),
      });
    }
    totalsArr.push({
      TotalName: "Total",
      TotalValue: parseFloat(TotalAfterVAT),
    });

    let orderPoints =
      (parseFloat(TotalAfterVAT) - parseFloat(effectiveShippingValue)) *
      parseFloat(redeemPointsPercentage / 100);

    if (pointsTotal > 0) {
      orderPoints -= parseFloat(pointsTotal);
    }
    dispatch(addPoints(orderPoints?.toFixed(2)));

    if (Area === t("checkout.all-areas")) {
      Area = "All Areas";
    }

    const packagesToSend = Packages?.map((pkg) => {
      const PackageProds = [];
      pkg.Products.forEach((prod) => {
        const newProd = {
          Barcode: prod.Barcode,
          Color: prod.Color,
          ProductName: prod.ProductName,
          Quantity: prod.Quantity,
          Size: prod.Size,
          Button: prod.Button
        }
        PackageProds.push(newProd);
      })
      return {
        Number: pkg.Number,
        Weight: pkg.Weight,
        Products: PackageProds
      }
    })

    const placeOrderRequest = {
      User,
      Email,
      FirstName,
      LastName,
      Address1,
      Address2,
      PostalCode,
      City,
      Country,
      Area,
      PaymentMethod,
      ShippingMethod,
      PaymentResponse,
      TotalBeforVAT,
      TotalAfterVAT,
      Status,
      Phone,
      ShippingCost,
      IsGift,
      GiftMessage,
      Notes,
      SpecialRequest,
      VoucherCode,
      CouponCode,
      DicountAmount,
      Products: productsArr,
      Totals: totalsArr,
      Packages: packagesToSend,
      AddressDisplayName,
      AddressMapLink,
      // UPDATE 26 FEB, 2026
      // shippingResponse: "From Submit Order Method!",
      shippingResponse: "",
    };

    // UPDATE 26 FEB, 2026
    console.log("Place Order Request: ", placeOrderRequest);

    setRequestData({
      data: placeOrderRequest,
    });
    setPlaceOrderRetries((prev) => prev + 1);
  };

  const formatDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    // Add suffix to the day (st, nd, rd, th)
    const daySuffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    return `${day}${daySuffix} of ${month}, ${year}`;
  };

  const prepareDHLShippingDataObject = () => {
    let Invoice = generateInvoiceNumber(PlaceOrderData?.data?.id);
    setInvoice(Invoice);
    const countryName = countriesArr?.find(
      (count) => count?.id == country
    )?.Name;
    const cityName = citiesArr?.find((cit) => cit?.id == city)?.Name;
    const length = settings?.find(
      (setting) => setting?.attributes?.SettingName == "DHL Length"
    )?.attributes?.SettingValue;
    const width = settings?.find(
      (setting) => setting?.attributes?.SettingName == "DHL Width"
    )?.attributes?.SettingValue;
    const height = settings?.find(
      (setting) => setting?.attributes?.SettingName == "DHL Height"
    )?.attributes?.SettingValue;

    const lineItems = [];
    let i = 1;
    for (const product of products) {
      const [color, size] = getColorAndSize(
        product?.product,
        product?.barcode,
        product?.selectedVariantId
      );
      const button = getButton(product?.product, product?.selectedButtonId, product?.selectedVariantId);

      let Quantity = product?.qty;

      const weight = calculateWeight([product], false);

      lineItems.push({
        number: i,
        description: `Color: ${color}, Size: ${size}${button ? `, Button: ${button}` : ""}`,
        price:
          product?.product?.attributes?.discountedPrice ??
          product?.product?.attributes?.Price,
        quantity: {
          value: Quantity,
          unitOfMeasurement: "PCS",
        },
        commodityCodes: [
          {
            typeCode: "outbound",
            value: "61044300",
          },
          {
            typeCode: "inbound",
            value: "61044300",
          },
        ],
        manufacturerCountry: "AE",
        weight: {
          netValue: weight,
          grossValue: weight,
        },
      });
      i++;
    }

    const pkgs = [];
    const inv = Invoice;

    packages.forEach((pkg) => {
      pkgs.push({
        weight: pkg?.Weight,
        customerReferences: [
          {
            value: pkg?.PackageNumber,
            typeCode: "CU",
          },
          {
            value: `ORD_${PlaceOrderData?.data?.id}`,
            typeCode: "CO",
          },
        ],
        dimensions: {
          length: parseFloat(length),
          width: parseFloat(width),
          height: parseFloat(height),
        },
      });
    });

    const dataObject = {
      shippingMethod: shipping,
      countryName: countryName,
      cityName: cityName,
      postalCode: postalCode,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      customerName: `${firstName} ${lastName}`,
      customerEmail: registerEmail,
      customerPhone: phone,
      shippingProductCode: shippingProductCode,
      deliveryNotes: deliveryNotes,
      // total: (parseFloat(subtotal) + parseFloat(vat)).toFixed(2),
      total: Number((parseFloat(subtotal) + parseFloat(vat)).toFixed(2)),
      totalCurrency: "AED",
      description: `Order #${PlaceOrderData?.data?.id
        } - Ordered at ${formatDate(new Date())}`,
      lineItems: lineItems,
      invoiceNum: inv,
      pkgs: pkgs,
      orderID: PlaceOrderData?.data?.id,
    };

    return dataObject;
  };

  const prepareSMSAShippingDataObject = () => {
    const countryName = countriesArr?.find(
      (count) => count?.id == country
    )?.Name;
    const cityName = citiesArr?.find((cit) => cit?.id == city)?.Name;

    const pkgs = [];
    packages.forEach((pkg) => {
      pkgs.push({
        weight: pkg?.Weight,
      });
    });

    const selectedShippingCode = shippingProvidersArr?.find(
      (provider) => provider?.Name == shipping
    )?.ShippingCode;

    const dataObject = {
      shippingMethod: shipping,
      countryName: countryName,
      cityName: cityName,
      postalCode: postalCode,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      customerName: `${firstName} ${lastName}`,
      customerPhone: phone,
      selectedShippingCode: selectedShippingCode,
      // total: (parseFloat(subtotal) + parseFloat(vat)).toFixed(2),
      total: Number((parseFloat(subtotal) + parseFloat(vat)).toFixed(2)),
      totalCurrency: "AED",
      description: `Order #${PlaceOrderData?.data?.id
        } - Ordered at ${formatDate(new Date())}`,
      pkgs: pkgs,
      orderID: PlaceOrderData?.data?.id,
    };

    return dataObject;
  };

  const prepareNetGlobalShippingDataObject = () => {
    const countryName = countriesArr?.find(
      (count) => count?.id == country
    )?.Name;
    // const cityName = citiesArr?.find((cit) => cit?.id == city)?.Name;
    const cityName = areasArr?.find((are) => are?.id == area)?.Name;
    const length = settings?.find(
      (setting) => setting?.attributes?.SettingName == "DHL Length"
    )?.attributes?.SettingValue;
    const width = settings?.find(
      (setting) => setting?.attributes?.SettingName == "DHL Width"
    )?.attributes?.SettingValue;
    const height = settings?.find(
      (setting) => setting?.attributes?.SettingName == "DHL Height"
    )?.attributes?.SettingValue;

    const pkgs = [];
    packages.forEach((pkg) => {
      pkgs.push({
        weight: pkg?.Weight,
        number: pkg?.PackageNumber,
        products: pkg?.Products,
      });
    });

    const dimensions = {
      length: parseFloat(length),
      width: parseFloat(width),
      height: parseFloat(height),
    };

    const dataObject = {
      shippingMethod: shipping,
      deliveryNotes: deliveryNotes,
      countryName: countryName,
      cityName: cityName,
      postalCode: postalCode,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      customerName: `${firstName} ${lastName}`,
      customerPhone: phone,
      customerEmail: registerEmail,
      description: `Order #${PlaceOrderData?.data?.id
        } - Ordered at ${formatDate(new Date())}`,
      pkgs: pkgs,
      orderID: PlaceOrderData?.data?.id,
      pkgDimensions: dimensions,
    };

    return dataObject;
  };

  // UPDATE 26 FEB, 2026
  const createOrderShipment = async (type, Invoice = "") => {
    // UPDATE 26 FEB, 2026
    let responseData = null;
    let shippingResponse = null;

    if (type == "DHL") {
      let base64EncodedPDF = "";
      let base64EncodedInvoice = "";
      let trackingNumber = "";
      let fileID = 0;
      let fileUploadError = false;
      let invoiceID = 0;
      let invoiceUploadError = false;

      const shippingObject = prepareDHLShippingDataObject();

      // UPDATE 26 FEB, 2026
      responseData = await createShipment(
        shippingObject?.countryName,
        shippingObject?.cityName,
        shippingObject?.postalCode,
        shippingObject?.addressLine1,
        shippingObject?.addressLine2,
        shippingObject?.customerName,
        shippingObject?.customerEmail,
        shippingObject?.customerPhone,
        shippingObject?.shippingProductCode,
        shippingObject?.deliveryNotes,
        shippingObject?.total,
        shippingObject?.totalCurrency,
        shippingObject?.description,
        shippingObject?.lineItems,
        shippingObject?.invoiceNum,
        shippingObject?.pkgs,
        shippingObject?.orderID
      );

      [trackingNumber, base64EncodedPDF, base64EncodedInvoice, shippingResponse] = responseData;

      console.log("Response Data (DHL): ", shippingResponse);

      if (base64EncodedPDF) {
        [fileID, fileUploadError] = await uploadBase64PdfToStrapi(
          base64EncodedPDF,
          `DHL shipment label for order #${PlaceOrderData?.data?.id}`
        );
      }
      if (base64EncodedInvoice) {
        [invoiceID, invoiceUploadError] = await uploadBase64PdfToStrapi(
          base64EncodedInvoice,
          `DHL invoice label for order #${PlaceOrderData?.data?.id}`
        );
      }

      return {
        base64EncodedPDF,
        base64EncodedInvoice,
        trackingNumber,
        fileID,
        fileUploadError,
        invoiceID,
        invoiceUploadError,
        // UPDATE 26 FEB, 2026
        shippingResponse
      };
    } else if (type?.includes("SMSA")) {
      let base64EncodedPDF = "";
      let trackingNumber = "";
      let fileID = 0;
      let fileUploadError = false;

      const shippingObject = prepareSMSAShippingDataObject();

      // UPDATE 26 FEB, 2026
      responseData = await createSMSAShipment(
        shippingObject?.countryName,
        shippingObject?.cityName,
        shippingObject?.postalCode,
        shippingObject?.addressLine1,
        shippingObject?.addressLine2,
        shippingObject?.customerName,
        shippingObject?.customerPhone,
        shippingObject?.selectedShippingCode,
        shippingObject?.total,
        shippingObject?.totalCurrency,
        shippingObject?.description,
        shippingObject?.pkgs,
        shippingObject?.orderID
      );

      [trackingNumber, base64EncodedPDF, shippingResponse] = responseData;

      console.log("Response Data (SMSA): ", shippingResponse);

      if (base64EncodedPDF) {
        [fileID, fileUploadError] = await uploadBase64PdfToStrapi(
          base64EncodedPDF,
          `SMSA shipment label for order #${PlaceOrderData?.data?.id}`
        );
      }
      return {
        base64EncodedPDF,
        trackingNumber,
        fileID,
        fileUploadError,
        // UPDATE 26 FEB, 2026
        shippingResponse
      };
    } else if (type?.includes("The Net Global")) {
      let pdfDocumentURL = "";
      let base64EncodedPDF = "";
      let trackingNumber = "";
      let fileID = 0;
      let fileUploadError = false;
      const shippingObject = prepareNetGlobalShippingDataObject();

      // UPDATE 26 FEB, 2026
      responseData = await createNetGlobalShipment(
        shippingObject?.orderID,
        shippingObject?.deliveryNotes,
        shippingObject?.countryName,
        shippingObject?.cityName,
        shippingObject?.postalCode,
        shippingObject?.addressLine1,
        shippingObject?.addressLine2,
        shippingObject?.customerName,
        shippingObject?.customerEmail,
        shippingObject?.customerPhone,
        shippingObject?.description,
        shippingObject?.pkgs,
        shippingObject?.pkgDimensions
      );

      [trackingNumber, pdfDocumentURL, shippingResponse] = responseData;

      console.log("Response Data (Net Global): ", shippingResponse);

      if (pdfDocumentURL) {
        base64EncodedPDF = await convertHTMLToPdf(pdfDocumentURL);
        [fileID, fileUploadError] = await uploadPdfToStrapi(
          base64EncodedPDF,
          `The Net Global shipment label for order #${PlaceOrderData?.data?.id}`
        );
      }

      return {
        base64EncodedPDF,
        trackingNumber,
        fileID,
        fileUploadError,
        // UPDATE 26 FEB, 2026
        shippingResponse
      };
    }

    return null;
  };

  // UPDATE 26 FEB, 2026
  const updatePaymentResponse = async (
    paymentResponse,
    paymentSuccess,
    stayInPage = false
  ) => {
    let paymentStatus = "";
    let trackingNumber = "";
    let base64EncodedPDF = "";
    let base64EncodedInvoice = "";
    let fileID = 0;
    let fileUploadError = false;
    let invoiceID = 0;
    let invoiceUploadError = false;

    // UPDATE 26 FEB, 2026
    // let shippingResponse = "From Update Payment Response Method!";
    let shippingResponse = "";
    // 
    let Invoice = generateInvoiceNumber(PlaceOrderData?.data?.id);
    setInvoice(Invoice);

    if (!paymentSuccess && stayInPage) {
      setNoRedirect(true);
    }

    if (Object.keys(paymentResponse).length === 0) {
      // cash on delivery
      paymentStatus = "Open";
    } else {
      paymentStatus = paymentSuccess ? "Paid" : "Payment Failed";
    }

    if (paymentStatus != "Payment Failed" && shipping == "DHL") {
      ({
        base64EncodedPDF,
        base64EncodedInvoice,
        trackingNumber,
        fileID,
        fileUploadError,
        invoiceID,
        invoiceUploadError,
        // UPDATE 26 FEB, 2026
        shippingResponse
      } = await createOrderShipment("DHL", Invoice));
    } else if (
      paymentStatus != "Payment Failed" &&
      shipping?.includes("SMSA")
    ) {
      ({
        base64EncodedPDF,
        trackingNumber,
        fileID,
        fileUploadError,
        // UPDATE 26 FEB, 2026
        shippingResponse
      } =
        await createOrderShipment("SMSA"));
    } else if (
      paymentStatus != "Payment Failed" &&
      shipping?.includes("The Net Global")
    ) {
      ({
        base64EncodedPDF,
        trackingNumber,
        fileID,
        fileUploadError,
        // UPDATE 26 FEB, 2026
        shippingResponse
      } =
        await createOrderShipment("The Net Global"));
    }

    // paid
    const newRequestData = {
      PaymentResponse: JSON.stringify(paymentResponse),
      Status: paymentStatus,
      InvoiceNumber: Invoice,
      // UPDATE 26 FEB, 2026
      shippingResponse: JSON.stringify(shippingResponse)
    };

    // UPDATE 26 FEB, 2026
    console.log("New Request Data: ", newRequestData);

    // add DHL props
    if (paymentStatus != "Payment Failed" && shipping == "DHL") {
      if (trackingNumber) newRequestData.DHLTrackingNumber = trackingNumber;
      if (fileID && !fileUploadError) newRequestData.DHLLabel = fileID;
      if (invoiceID && !invoiceUploadError)
        newRequestData.DHLInvoice = invoiceID;
    }

    // add SMSA props
    if (paymentStatus != "Payment Failed" && shipping?.includes("SMSA")) {
      if (trackingNumber) newRequestData.DHLTrackingNumber = trackingNumber;
      if (fileID && !fileUploadError) newRequestData.DHLLabel = fileID;
    }

    // add Net Global props
    if (
      paymentStatus != "Payment Failed" &&
      shipping?.includes("The Net Global")
    ) {
      if (trackingNumber) newRequestData.DHLTrackingNumber = trackingNumber;
      if (fileID && !fileUploadError) newRequestData.DHLLabel = fileID;
    }

    setUpdateOrderRequestData({ data: newRequestData });
    setUpdateOrderRetries((prev) => prev + 1);
  };

  const checkIsProductRegionallyLocked = (prods) => {
    const filteredProducts = prods?.filter((prod) => prod);
    if (filteredProducts?.length <= 0) return true;

    const PERFUME_CATEGORY_ID = process.env.REACT_APP_PERFUME_CATEGORY_ID;
    let isAnyProductLocked = false;

    for (const product of filteredProducts) {
      for (const category of product?.product?.attributes?.Categories?.data) {
        if (category?.id == PERFUME_CATEGORY_ID) {
          isAnyProductLocked = true;
        }
      }

      if (isAnyProductLocked) break;
    }

    return isAnyProductLocked;
  };

  const isFormValid = () => {
    const areaName = areasArr?.find((areaObj) => areaObj?.id == area)?.Name;
    const resolvedCountry = countriesArr?.find((countObj) => countObj?.id == country)?.Name;
    const resolvedCity = citiesArr?.find((cityObj) => cityObj?.id == city)?.Name;
    const commonFields = [
      country,
      city,
      !!resolvedCountry,
      !!resolvedCity,
      area ? !!areaName : true,
      addressLine1?.trim() !== "",
      shipping,
      paymentMethod,
      shippingValue > 0,
      postalCode,
      isAddressValid(addressLine1),
      isAddressValid(addressLine2),
    ];

    if (Object.keys(user).length > 0) {
      return commonFields.every(Boolean);
    }

    const additionalFields = [
      registerEmail,
      firstName,
      lastName,
      phone,
      isPhoneValid(phone),
    ];
    return [...commonFields, ...additionalFields].every(Boolean);
  };

  const updateShippingArray = async (
    products,
    activeProviderNames = null,
    ratesOverride = null
  ) => {
    // Prefer freshly fetched rates when a submit-time revalidation found a
    // provider unresolvable. Falling back to the mount-time list is what would
    // re-add a provider whose rate rows were removed in the admin.
    const effectiveRates = ratesOverride || shippingRatesArr;

    const requestId = ++shippingRequestId.current;
    const isCurrentRequest = () => requestId === shippingRequestId.current;

    const newShippingProviders = [];
    const UAENonProviders = ["DHL", "The Net Global"];
    let shippingRate = 0;
    for (const shippingProvider of shippingProvidersData) {
      switch (country) {
        case 231: // UAE
          if (!UAENonProviders?.includes(shippingProvider?.attributes?.Name)) {
            shippingRate = getShippingRate(
              shippingProvider?.attributes?.Name,
              effectiveRates,
              country,
              city,
              area,
              products,
              activeProviderNames
            );
            if (shippingRate != 0) {
              newShippingProviders.push({
                Name: shippingProvider?.attributes?.Name,
                DaysEstimate: shippingProvider?.attributes?.DeliveryTime,
                Value: shippingRate,
                ShippingCode: shippingProvider?.attributes?.Code,
              });
            }
          }
          break;
        default: // Rest of World
          if (shippingProvider?.attributes?.Name != "DHL") {
            const shippingRate = getShippingRate(
              shippingProvider?.attributes?.Name,
              effectiveRates,
              country,
              city,
              area,
              products,
              activeProviderNames
            );
            if (shippingRate != 0) {
              newShippingProviders.push({
                Name: shippingProvider?.attributes?.Name,
                DaysEstimate: shippingProvider?.attributes?.DeliveryTime,
                Value: shippingRate,
                ShippingCode: shippingProvider?.attributes?.Code,
              });
            }
          } else {
            const countryName = countriesArr?.find(
              (count) => count?.id == country
            )?.Name;
            const cityName = citiesArr?.find((cit) => cit?.id == city)?.Name;
            const weight = calculateWeight(products);
            let daysEstimate = "";
            let productCode = "";
            [shippingRate, daysEstimate, productCode] = await getDHLRates(
              weight,
              countryName,
              cityName,
              postalCode,
              settings
            );
            if (shippingRate > 0 && daysEstimate) {
              newShippingProviders.push({
                Name: shippingProvider?.attributes?.Name,
                DaysEstimate: daysEstimate,
                Value: Math.ceil(shippingRate),
              });
              if (!isCurrentRequest()) return;
              setShippingProductCode(productCode);
            }
          }
          break;
      }
    }

    // A newer lookup has already started; discard this stale result.
    if (!isCurrentRequest()) return;
    setShippingProvidersArr(newShippingProviders);
  };

  const updateAddressObject = ({
    DisplayName,
    Address1,
    Address2,
    PostCode,
    Country,
    City,
    City2,
    Area,
    Area2,
    MapLink,
  }) => {
    if (Object.keys(user)?.length > 0) return;

    const NewAddressViaMap = {
      Country: 0,
      CountryName: "",
      City: 0,
      CityName: "",
      CityName2: "",
      Area: 0,
      AreaName: "",
      AreaName2: "",
      AddressLine1: "",
      AddressLine2: "",
      PostalCode: "",
      FirstName: "",
      LastName: "",
      MapLink: "",
      DisplayName: "",
      SelectedPosition: [],
    };
    if (Address1?.trim() === "" && Address2?.trim() !== "") {
      NewAddressViaMap.AddressLine1 = Address2;
    } else if (Address1?.trim() !== "") {
      NewAddressViaMap.AddressLine1 = Address1;
      NewAddressViaMap.AddressLine2 = Address2;
    } else {
      NewAddressViaMap.AddressLine1 = Area;
      NewAddressViaMap.AddressLine2 = Address2;
    }
    NewAddressViaMap.PostalCode = PostCode?.trim() === "" ? "00000" : PostCode;
    const newCountry = countriesArr?.find(
      (country) => country?.Name === Country
    );
    if (newCountry) {
      NewAddressViaMap.Country = newCountry?.id;
      NewAddressViaMap.CountryName = newCountry?.Name;
    }
    NewAddressViaMap.CityName = City;
    NewAddressViaMap.CityName2 = City2;
    NewAddressViaMap.AreaName = Area;
    NewAddressViaMap.AreaName2 = Area2;
    NewAddressViaMap.MapLink = MapLink;
    NewAddressViaMap.DisplayName = DisplayName;
    const params = new URL(MapLink).searchParams;

    const lat = params.get("mlat");
    const lon = params.get("mlon");
    NewAddressViaMap.SelectedPosition = [lat, lon];
    setAddressViaMap(NewAddressViaMap);
  };

  const updateAddressFromMap = () => {
    try {
      // Only proceed if we have valid coordinates and data
      if (
        AddressViaMap.SelectedPosition?.length === 2 &&
        AddressViaMap.MapLink
      ) {
        setCountry(AddressViaMap.Country);
        setCityViaMap(AddressViaMap.CityName);
        setCity2ViaMap(AddressViaMap.CityName2);
        setIsCitySorted((prev) => !prev);
        setAreaViaMap(AddressViaMap.AreaName);
        setArea2ViaMap(AddressViaMap.AreaName2);
        setPostalCode(AddressViaMap.PostalCode);
        setMapLink(AddressViaMap.MapLink);
        setDisplayName(AddressViaMap.DisplayName);
        setSelectedPosition(AddressViaMap.SelectedPosition);
      }
    } catch (error) {
      console.error("Error updating address from map:", error);
      // Silently fail without showing errors to end user
      // Could also add error handling logic here if needed
    }
  };

  const submitPointsToRedeem = async (e) => {
    e.preventDefault();

    if (parseFloat(pointsToRedeem) > parseFloat(userPoints)) {
      setPointsErrorMessage(t("errors.not-enough-points"));
      setTimeout(() => {
        setPointsErrorMessage("");
      }, 3000);
      return;
    }

    if (parseFloat(pointsToRedeem) < parseFloat(minimumPoints)) {
      setPointsErrorMessage(t("errors.minimum-points") + " " + minimumPoints);
      setTimeout(() => {
        setPointsErrorMessage("");
      }, 3000);
      return;
    }

    setIsUsingPoints(true);
    const newTotal = parseFloat(total) + parseFloat(pointsTotal);
    setPointsTotal(
      pointsToRedeem >= newTotal
        ? parseFloat(newTotal)
        : parseFloat(pointsToRedeem)
    );
  };

  const isAddressValid = (address) => {
    const value = address;
    const allowedPattern = /^[A-Za-z0-9\u0600-\u06FF ,.\-_\/'()]*$/;

    if (address?.length > 44) return false;

    if (allowedPattern.test(value)) return true;
    else return false;
  };

  const getCountryName = (country) => {
    let countryName = country?.data?.attributes?.Name;
    if (currentLanguage != "en") {
      const localization = country?.data?.attributes?.localizations?.data?.find(
        (local) => local?.attributes?.locale === currentLanguage
      );
      if (localization) {
        countryName = localization?.attributes?.Name;
      }
    }

    return countryName;
  };

  const getCityName = (city) => {
    let cityName = city?.data?.attributes?.Name;
    if (currentLanguage != "en") {
      const localization = city?.data?.attributes?.localizations?.data?.find(
        (local) => local?.attributes?.locale === currentLanguage
      );
      if (localization) {
        cityName = localization?.attributes?.Name;
      }
    }

    return cityName;
  };

  // Re-validate persisted promo on page load
  useEffect(() => {
    const revalidate = async () => {
      if (checkout?.isPromoApplied && checkout?.promo) {
        const isValid = await isPromoValid(user, checkout?.promo, checkout?.isVoucher);
        if (!isValid) {
          dispatch(disableIsPromoApplied());
          dispatch(disableIsVoucher());
          dispatch(removePromo());
          // setPromoValue("");
        }
      }
    };
    revalidate();
  }, []);

  useEffect(() => {
    if (!promoLoading && promoData) {
      applyPromo(promoData, false);
      setIsPromoLoading(false);
    } else if (promoLoading && !promoError) {
      setIsPromoLoading(true);
    } else if (!promoLoading && promoError && !promoData) {
      setIsPromoLoading(false);
      setIsPromoError(true);
    }
  }, [promoLoading]);

  useEffect(() => {
    if (!voucherLoading && voucherData) {
      applyPromo(voucherData, true);
      setIsVoucherLoading(false);
    } else if (voucherLoading && !voucherError) {
      setIsVoucherLoading(true);
    } else if (!voucherLoading && voucherError && !voucherData) {
      setIsVoucherLoading(false);
      setIsVoucherError(true);
    }
  }, [voucherLoading]);

  useEffect(() => {
    if (!addressesLoading && addressesData) {
      const addressesArray = [];
      addressesData?.forEach((address) => {
        const newAddress = {
          id: address?.id,
          Country: address?.attributes?.Country?.data?.id,
          City: address?.attributes?.City?.data?.id,
          Area: address?.attributes?.Area?.data?.id,
          Address1: address?.attributes?.Address1,
          Address2: address?.attributes?.Address2,
          PostCode: address?.attributes?.Postcode,
          FirstName: address?.attributes?.FirstName,
          LastName: address?.attributes?.LastName,
          DisplayName: address?.attributes?.DisplayName,
          MapLink: address?.attributes?.MapLink,
        };

        let CountryName = address?.attributes?.Country?.data?.attributes?.Name;
        let CityName = address?.attributes?.City?.data?.attributes?.Name;
        let AreaName =
          address?.attributes?.Area?.data?.attributes?.Name ??
          t("checkout.all-areas");

        newAddress.CountryName = CountryName;
        newAddress.CityName = CityName;
        newAddress.AreaName = AreaName;

        const name = [
          getCountryName(address?.attributes?.Country),
          getCityName(address?.attributes?.City),
          AreaName,
          newAddress.Address1,
          newAddress.PostCode,
        ];
        newAddress.Name = name?.join(", ");

        addressesArray.push(newAddress);
      });

      setAddressesArr(addressesArray);
      setSelectedAddress(addressesArray[0]?.id);
      setAreAddressesLoading(false);
    } else if (addressesLoading && !addressesError) {
      setAreAddressesLoading(true);
    } else if (!addressesLoading && addressesError && !addressesData) {
      setAreAddressesLoading(false);
      setAreAddressesError(true);
    }
    // }, [addressesLoading]);
  }, [addressesLoading, addressesData, addressesError]);

  useEffect(() => {
    const Address = addressesArr?.find(
      (address) => address?.id == selectedAddress
    );
    if (Address) {
      setFirstName(Address?.FirstName);
      setLastName(Address?.LastName);
      // setCountry(Address?.Country ?? 0);
      setCountry((prev) => Address?.Country || prev || 231);
      if (Address?.Country) {
        setCountriesArr((prev) =>
          prev.some((c) => c?.id == Address.Country)
            ? prev
            : [
              ...prev,
              { Name: Address.CountryName, id: Address.Country, Locale: undefined },
            ]
        );
      }
      setSelectedCity(Address?.CityName);
      setSelectedArea(Address?.AreaName);
      setAddressLine1(Address?.Address1);
      setAddressLine2(Address?.Address2);
      setPostalCode(Address?.PostCode);
      setCity(Address?.City ?? 0);
      setArea(Address?.Area ?? 0);
      isCityFromSaved.current = true;
      isAreaFromSaved.current = true;
      if (Address?.MapLink) {
        const params = new URL(Address?.MapLink).searchParams;

        const lat = params.get("mlat");
        const lon = params.get("mlon");
        setSelectedPosition([lat, lon]);
        setDisplayName(Address?.DisplayName);
        setMapLink(Address?.MapLink);
      }
    }
  }, [selectedAddress]);

  useEffect(() => {
    const handlePlaceOrder = async () => {
      if (PlaceOrderLoading) {
        setPlaceOrderLoading(true);
        return;
      }
      setPlaceOrderLoading(false);

      if (PlaceOrderStatus !== 200 && placeOrderRetries > 0) {
        setPlaceOrderError(true);
        setCheckoutBtnDisabled(false);

        if (PlaceOrderStatus === 400) {
          setErrorMessage(PlaceOrderErrorMessage);
        } else {
          setErrorMessage(t("errors.unknown"));
        }
        return;
      }

      if (PlaceOrderData) {
        setPlaceOrderData(PlaceOrderData);
        setPlaceOrderError(false);
        setPlaceOrderLoading(false);
        dispatch(setOrderID(PlaceOrderData?.data?.id));
        await updateOrderWithInvoice(PlaceOrderData?.data?.id);
        handlePayment(
          PlaceOrderData?.data?.id,
          PlaceOrderData?.data?.attributes?.TotalAfterVAT
        );
      }
    };
    handlePlaceOrder();
  }, [PlaceOrderLoading]);

  useEffect(() => {
    if (NetworkLoading) {
      return;
    }

    if (NetworkError !== "") {
      setErrorMessage(NetworkError);
      setTimeout(() => {
        setErrorMessage("");
        setCheckoutBtnDisabled(false);
      }, 5000);
      return;
    }

    if (NetworkPaymentLink) {
      let shippingDataObject = {};
      if (shipping == "DHL") {
        shippingDataObject = prepareDHLShippingDataObject();
      } else if (shipping?.includes("SMSA")) {
        shippingDataObject = prepareSMSAShippingDataObject();
      } else if (shipping?.includes("The Net Global")) {
        shippingDataObject = prepareNetGlobalShippingDataObject();
      }
      dispatch(addShippingData(shippingDataObject));
      const redirectOrderId = PlaceOrderData?.data?.id || checkout?.orderID;
      if (redirectOrderId) {
        sessionStorage.removeItem("instantBuyOrderId");
        sessionStorage.setItem("instantBuyOrderId", String(redirectOrderId));
      }
      window.location.href = NetworkPaymentLink;
    }
  }, [NetworkLoading]);

  useEffect(() => {
    if (UpdateOrderLoading) {
      setUpdateOrderLoading(true);
      return;
    }
    setUpdateOrderLoading(false);

    if (UpdateOrderStatus !== 200 && updateOrderRetries > 0) {
      setUpdateOrderError(true);
      setCheckoutBtnDisabled(false);

      if (UpdateOrderStatus === 400) {
        setErrorMessage(UpdateOrderErrorMessage);
      } else {
        setErrorMessage(t("errors.unknown"));
      }
      retryUpdateOrder();
      return;
    }

    if (UpdateOrderData) {
      setUpdateOrderData(UpdateOrderData);
      setUpdateOrderError(false);
      setUpdateOrderLoading(false);
      if (!noRedirect) {
        navigate("/order-submitted");
      } else {
        setErrorMessage(t("errors.unknown"));
        setTimeout(() => {
          setCheckoutBtnDisabled(false);
          setErrorMessage("");
        }, 5000);
      }
    }
  }, [UpdateOrderLoading]);

  useEffect(() => {
    if (!productsLoading && productsData) {
      if (productsIds.length === 0) {
        setProducts([]);
      } else {
        const newProducts = processProducts();
        setProducts(newProducts);
      }
      setAreProductsLoading(false);
    } else if (productsLoading && !productsError) {
      setAreProductsLoading(true);
    } else if (!productsLoading && productsError && !productsData) {
      setAreProductsLoading(false);
      setAreProductsError(true);
    }
    // }, [productsLoading]);
  }, [productsLoading, productsData, productsError]);

  useEffect(() => {
    const newProducts = processProducts();
    setProducts(newProducts);
  }, [productsIds]);

  useEffect(() => {
    const isCheckoutRegionallyLocked = checkIsProductRegionallyLocked(products);
    let errorMsg = "";
    if (isCheckoutRegionallyLocked && country != 231) {
      errorMsg = t("checkout.product-region-lock");
    } else if (
      errorMessage === t("checkout.product-region-lock") &&
      (!isCheckoutRegionallyLocked ||
        (isCheckoutRegionallyLocked && country == 231))
    ) {
      errorMsg = "";
    }
    setErrorMessage(errorMsg);
  }, [country, products]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      processTotals();
    }, 500);
    return () => clearTimeout(debounceTimeout);
  }, [
    products,
    checkout?.promo,
    pointsTotal,
    shippingValue,
    hasFreeShipping,
    fixedShipping,
  ]);

  useEffect(() => {
    if (!zonesLoading && !zonesError && zonesData) {
      setCountriesArr(
        zonesData.countries.map((country) => {
          return {
            Name: country?.attributes?.Name,
            id: country?.id,
            Locale: country?.attributes?.localizations,
          };
        })
      );
      // setCountry(231);
      setCountry((prev) => prev || 231);
    }
    // }, [zonesLoading, zonesError]);
  }, [zonesLoading, zonesError, zonesData]);

  useEffect(() => {
    if (!paymentMethodsLoading && !paymentMethodsError && paymentMethodsData) {
      const newPaymentMethods = [];
      paymentMethodsData.forEach((paymentMethod) => {
        if (paymentMethod?.attributes?.Countries?.data?.length > 0) {
          for (const paymentCountry of paymentMethod?.attributes?.Countries
            ?.data) {
            if (country == paymentCountry?.id) {
              newPaymentMethods.push({
                Name: paymentMethod?.attributes?.Name,
              });
            }
          }
        } else {
          newPaymentMethods.push({
            Name: paymentMethod?.attributes?.Name,
          });
        }
      });
      setPaymentMethodsArr(newPaymentMethods);
    }
  }, [paymentMethodsLoading, paymentMethodsError, country]);

  useEffect(() => {
    if (!shippingRatesLoading && !shippingRatesError && shippingRatesData) {
      setShippingRatesArr(shippingRatesData);
    }
  }, [shippingRatesLoading, shippingRatesError]);

  useEffect(() => {
    if (!siteSettingsLoading && !siteSettingsError && siteSettingsData) {
      setSettings(siteSettingsData);

      const pointsRedeemPercentageSettingsValue = parseFloat(
        siteSettingsData?.find(
          (setting) => setting?.attributes?.SettingName === "Redeem Percentage "
        )?.attributes?.SettingValue
      );
      const minimumPointsSettingsValue = parseFloat(
        siteSettingsData?.find(
          (setting) =>
            setting?.attributes?.SettingName === "Redeem Points Threshold"
        )?.attributes?.SettingValue
      );
      const canRedeemPointsSettingsValue = siteSettingsData?.find(
        (setting) => setting?.attributes?.SettingName === "Redeem Status"
      )?.attributes?.Status;

      setRedeemPointsPercentage(pointsRedeemPercentageSettingsValue);
      setMinimumPoints(minimumPointsSettingsValue);
      setCanRedeem(canRedeemPointsSettingsValue);
    }
  }, [siteSettingsLoading, siteSettingsError]);

  useEffect(() => {
    const getPoints = async () => {
      const points = await getUserPoints(user?.id);
      setUserPoints(points);
    };

    if (Object.keys(user)?.length > 0 && canRedeem) {
      getPoints();
    }
  }, [canRedeem, user]);

  useEffect(() => {
    if (!offersLoading && !offersError && offersData) {
      setOffers(offersData);
    }
  }, [offersLoading, offersError]);

  useEffect(() => {
    if (!clearancesLoading && !clearancesError && clearancesData) {
      setClearances(clearancesData);
    }
  }, [clearancesLoading, clearancesError]);

  useEffect(() => {
    if (!fixedShippingLoading && !fixedShippingError && fixedShippingData) {
      setFixedShippingArr(fixedShippingData);
    }
  }, [fixedShippingLoading, fixedShippingError]);

  // Always refresh discount rules when the checkout mounts so a rule changed
  // in the admin (e.g. free shipping toggled on) is reflected immediately,
  // without requiring the customer to hard-refresh the page.
  useEffect(() => {
    const refreshDiscountRules = async () => {
      try {

        const rulesParams = new URLSearchParams({
          populate: "deep",
          "filters[Status][$eq]": true,
          // cache-bust so a rule toggled in the admin (e.g. free shipping)
          // is reflected on a normal page load without a hard refresh
          _: Date.now(),
        });
        const rulesRes = await makeRequest.get(
          `/discount-rules?${rulesParams.toString()}`
        );
        if (Array.isArray(rulesRes?.data?.data)) {
          dispatch(setDiscountRules(rulesRes.data.data));
        }
      } catch (e) {
        console.error("Failed to refresh discount rules on checkout:", e);
      }
    };
    refreshDiscountRules();
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !productsLoading &&
      !productsError &&
      products?.length > 0 &&
      ((!offersLoading && !offersError && offers.length > 0) ||
        (!clearancesLoading && !clearancesError && clearances.length > 0))
    ) {
      const newProducts = processProducts();
      setProducts(newProducts);
    }
  }, [offers, clearances, productsIds]);

  useEffect(() => {
    const grossSubtotal = products?.reduce((sum, prod) => {
      const price =
        prod?.product?.attributes?.discountedPrice ??
        prod?.product?.attributes?.Price;
      return sum + (parseFloat(price) || 0) * (parseFloat(prod?.qty) || 1);
    }, 0);

    const isFreeShipping = calculateFreeShipping(
      products,
      discountRules,
      grossSubtotal,
      shipping,
      country
    );
    setHasFreeShipping(isFreeShipping);

    if (!isFreeShipping && fixedShippingArr?.length > 0) {
      const { hasCustomShippingRate, customShippingRate } =
        checkCustomShippingRates(
          fixedShippingArr,
          grossSubtotal,
          shipping,
          country
        );
      setFixedShippingValue(customShippingRate);
      setFixedShipping(hasCustomShippingRate);
    }
  }, [country, shipping, products, fixedShippingArr, discountRules]);

  useEffect(() => {
    if (isPhoneValid(phone) && phone?.trim() !== "") {
      setIsPhoneNumberValid(true);
    } else {
      setIsPhoneNumberValid(false);
    }
  }, [phone]);

  // Single debounced driver for the shipping options. Previously two separate
  // effects (500ms and 1000ms) both called `updateShippingArray`, which meant
  // two identical live DHL lookups per selection and a loading flag that
  // cleared while one of them was still running.
  useEffect(() => {
    const isUAE = country === 231;
    // Editing the address re-quotes against the destination postal code, so it
    // keeps the longer settle. Selection changes settle faster.
    const isAddressChange =
      prevAddressRef.current.postalCode !== postalCode ||
      prevAddressRef.current.addressLine1 !== addressLine1;
    prevAddressRef.current = { postalCode, addressLine1 };

    const debounceTimeout = setTimeout(() => {
      if (
        !shippingRatesArr?.length ||
        shippingProvidersLoading ||
        shippingProvidersError ||
        !shippingProvidersData ||
        !CityData ||
        (!isUAE && !settings?.length) ||
        !country ||
        !city
      ) {
        return;
      }

      // Never quote against a city that is not in the resolved city list:
      // an unresolved city sends `undefined` as the DHL destination and the
      // lookup silently fails.
      if (!citiesArr?.some((cityObj) => cityObj?.id == city)) {
        return;
      }

      // Outside the UAE the DHL rate is derived from country, city, weight and
      // postal code only, so it must not be blocked on the areas request.
      // Inside the UAE the area is part of the rate, so it still waits.
      if (isUAE && (CityLoading || AreaLoading || !AreaData)) {
        return;
      }

      const newProducts = processProducts();
      setProducts(newProducts);
      updateShippingArray(newProducts);
      setPostalCode((prev) =>
        prev?.trim() === "" && country === 231 ? "00000" : prev
      );
    }, isAddressChange ? 1000 : 500);

    return () => clearTimeout(debounceTimeout);
  }, [
    country,
    city,
    area,
    CityData,
    CityLoading,
    AreaData,
    AreaLoading,
    citiesArr,
    productsIds,
    areProductsLoading,
    shippingProvidersLoading,
    shippingProvidersError,
    shippingRatesArr,
    productsData,
    settings,
    postalCode,
    addressLine1,
  ]);

  useEffect(() => {
    let shippingRate = 0;
    const newShippingProvider = shippingProvidersArr?.find(
      (provider) => provider?.Name == shipping
    );
    if (newShippingProvider) {
      shippingRate = newShippingProvider?.Value;
    } else if (shipping) {
      setShipping("");
    }
    setShippingValue(shippingRate);
  }, [shipping, country, city, area, products, shippingProvidersArr]);

  useEffect(() => {
    if (!CityLoading && !CityError && CityData) {
      const newCitiesArr = [
        {
          Name: t("checkout.please-select"),
          id: "",
        },
      ];
      if (CityData?.cities) {
        for (const newCity of CityData?.cities) {
          if (newCity?.attributes?.Country?.data?.id == country) {
            newCitiesArr.push({
              Name: newCity?.attributes?.Name,
              id: newCity?.id,
              Locale: newCity?.attributes?.localizations,
            });
          }
        }
      }

      if (cityViaMap?.trim() !== "" && newCitiesArr?.length > 0) {
        newCitiesArr?.sort((a, b) => {
          if (cityViaMap?.includes(a?.Name)) return -1;
          else if (cityViaMap?.includes(b?.Name)) return 1;
          else return 0;
        });
      }

      if (
        city2ViaMap?.trim() !== "" &&
        !cityViaMap?.includes(newCitiesArr[0]?.Name) &&
        newCitiesArr?.length > 0
      ) {
        newCitiesArr?.sort((a, b) => {
          if (city2ViaMap?.includes(a?.Name)) return -1;
          else if (city2ViaMap?.includes(b?.Name)) return 1;
          else return 0;
        });
      }

      if (selectedCity?.trim() !== "") {
        newCitiesArr?.sort((a, b) => {
          if (selectedCity?.includes(a?.Name)) return -1;
          else if (selectedCity?.includes(b?.Name)) return 1;
          else return 0;
        });
      }

      if (newCitiesArr.length === 0) {
        setCitiesArr([]);
        setCity(0);
      } else {
        setCitiesArr(newCitiesArr);
        if (!isCityFromSaved.current) {
          setCity(newCitiesArr[0]?.id ?? 0);
        }
        isCityFromSaved.current = false;
      }

      if (
        cityViaMap?.trim() !== "" &&
        city2ViaMap?.trim() !== "" &&
        newCitiesArr?.length > 0
      ) {
        setCityViaMap("");
        setCity2ViaMap("");
        setIsAreaSorted((prev) => !prev);
      }
    }
  }, [country, CityData, CityLoading, CityError, isCitySorted, selectedCity]);

  // UPDATE 27 FEB, 2026
  useEffect(() => {
    // UPDATE 27 FEB, 2026
    const currentCountryName = countriesArr?.find(
      (countObj) => countObj?.id == country
    )?.Name;

    if (!AreaLoading && AreaData) {
      let newAreasArr = [];
      if (AreaData?.areas) {
        for (const newArea of AreaData?.areas) {
          if (newArea?.attributes?.City?.data?.id == city) {
            newAreasArr.push({
              Name: newArea?.attributes?.Name,
              id: newArea?.id,
              Locale: newArea?.attributes?.localizations,
            });
          }
        }
      }

      // UPDATE 27 FEB, 2026
      const restrictedCountries = [
        "Jordan", "Lebanon", "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Iraq",
        "الأردن", "لبنان", "الإمارات العربية المتحدة", "السعودية", "قطر", "الكويت", "البحرين", "العراق"
      ];

      // UPDATE 27 FEB, 2026
      if (restrictedCountries.includes(currentCountryName)) {
        newAreasArr = newAreasArr.filter(
          (a) => a.Name !== t("checkout.all-areas") && a.Name !== "All Areas"
        );
      }

      if (areaViaMap?.trim() !== "") {
        newAreasArr?.sort((a, b) => {
          if (areaViaMap?.includes(a?.Name)) return -1;
          else if (areaViaMap?.includes(b?.Name)) return 1;
          else return 0;
        });
      }

      if (
        area2ViaMap?.trim() !== "" &&
        !areaViaMap?.includes(newAreasArr[0]?.Name)
      ) {
        newAreasArr?.sort((a, b) => {
          if (area2ViaMap?.includes(a?.Name)) return -1;
          else if (area2ViaMap?.includes(b?.Name)) return 1;
          else return 0;
        });
      }

      if (selectedArea?.trim() !== "") {
        newAreasArr?.sort((a, b) => {
          if (selectedArea?.includes(a?.Name)) return -1;
          else if (selectedArea?.includes(b?.Name)) return 1;
          else return 0;
        });
      }

      if (
        !areaViaMap?.includes(newAreasArr[0]?.Name) &&
        !area2ViaMap?.includes(newAreasArr[0]?.Name) &&
        !selectedArea?.includes(newAreasArr[0]?.Name)
      ) {
        newAreasArr?.sort((a, b) => {
          if (a?.Name == t("checkout.all-areas")) return -1;
          else if (b?.Name == t("checkout.all-areas")) return 1;
          else return 0;
        });
      }

      if (newAreasArr.length === 0) {
        setAreasArr([]);
        setArea(0);
      } else {
        setAreasArr(newAreasArr);
        if (!isAreaFromSaved.current) {
          setArea(newAreasArr[0]?.id ?? 0);
        }
        isAreaFromSaved.current = false;
      }

      if (
        areaViaMap?.trim() !== "" &&
        area2ViaMap?.trim() !== "" &&
        newAreasArr?.length > 0
      ) {
        setAreaViaMap("");
        setArea2ViaMap("");
      }
    }
  }, [city, AreaData, AreaLoading, AreaError, isAreaSorted, selectedArea, country, countriesArr]);

  useEffect(() => {
    if (productsIds.length === 0) {
      navigate("/");
    }
  }, [productsIds]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const errorParam = searchParams.get("error");
    if (errorParam) {
      setErrorMessage(errorParam);
      if (placeOrderBtn.current) {
        placeOrderBtn.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
    }
  }, []);

  useEffect(() => {
    // Only proceed if we have valid coordinates and data
    if (
      AddressViaMap.SelectedPosition?.length === 2 &&
      AddressViaMap.MapLink &&
      !Object.keys(user).length > 0 // Don't auto-update for logged in users
    ) {
      updateAddressFromMap();
    }
  }, [AddressViaMap]);

  useEffect(() => {
    if (Object.keys(user).length > 0) {
      setFirstName(user?.FirstName);
      setLastName(user?.LastName);
      setPhone(user?.PhoneNumber);
      setRegisterEmail(user?.email);
    }
  }, []);

  useEffect(() => {
    getSiteSettings();
    getOffers();
    getClearances();
    getFixedShipping();
    const interval = setInterval(() => {
      getOffers();
      getClearances();
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="checkout">
      <LoaderOverlay
        loadingState={placeOrderLoading}
        errorState={placeOrderError}
        setErrorState={setPlaceOrderError}
        retryFunc={retryPlaceOrder}
      />
      {!placeOrderLoading && !placeOrderError && (
        <LoaderOverlay
          loadingState={siteSettingsLoading}
          errorState={siteSettingsError}
          setErrorState={siteSettingsSetError}
          retryFunc={siteSettingsRetry}
        />
      )}
      {!placeOrderLoading &&
        !placeOrderError &&
        !siteSettingsLoading &&
        !siteSettingsError && (
          <LoaderOverlay
            loadingState={offersLoading}
            errorState={offersError}
            setErrorState={offersSetError}
            retryFunc={offersRetry}
          />
        )}
      {!placeOrderLoading &&
        !placeOrderError &&
        !siteSettingsLoading &&
        !siteSettingsError &&
        !offersLoading &&
        !offersError && (
          <LoaderOverlay
            loadingState={clearancesLoading}
            errorState={clearancesError}
            setErrorState={clearancesSetError}
            retryFunc={clearancesRetry}
          />
        )}
      {!placeOrderLoading &&
        !placeOrderError &&
        !siteSettingsLoading &&
        !siteSettingsError &&
        !offersLoading &&
        !offersError &&
        !clearancesLoading &&
        !clearancesError && (
          <LoaderOverlay
            loadingState={fixedShippingLoading}
            errorState={fixedShippingError}
            setErrorState={fixedShippingSetError}
            retryFunc={fixedShippingRetry}
          />
        )}
      {!foloosiReferenceTokenLoading &&
        !foloosiReferenceTokenError &&
        foloosiReferenceToken && (
          <FoloosiPayment
            referenceToken={foloosiReferenceToken}
            merchantKey={process.env.REACT_APP_FOLOOSI_MERCHANT_KEY}
            redirect={false} // Set to true if hosting payment is needed
            open={true}
            updatePaymentResponse={updatePaymentResponse}
          />
        )}
      <div className="checkout-banner">
        {offerTip.trim() !== "" && (
          <h2 className="offer-tip-message">{offerTip}</h2>
        )}
      </div>
      <div className="checkout-container">
        <div className="checkout-info">
          <div className="checkout-info-container">
            <h1 className="checkout-title">{t("checkout.checkout")}</h1>

            {Object.keys(user).length === 0 && (
              <>
                <h3 className="checkout-login">
                  {t("checkout.have-an-account")}{" "}
                  <Link to="/login?to=checkout" className="checkout-login-link">
                    {t("checkout.login")}
                  </Link>
                </h3>

                <div className="checkout-info-new-login-container">
                  <InputWithInnerLabel
                    stateValue={registerEmail}
                    setStateValue={setRegisterEmail}
                    type={"email"}
                    labelText={t("checkout.new-email") + "*"}
                    idText={"email"}
                    redBorder={true}
                  />
                </div>

                <div className="checkout-info-email-me">
                  <input
                    type="checkbox"
                    id="checkout-info-email-me-input"
                    checked={emailMe}
                    value={emailMe}
                    onChange={(e) => setEmailMe(e.target.checked)}
                  />
                  <label
                    htmlFor="checkout-info-email-me-input"
                    className="checkout-info-email-label"
                  >
                    {t("checkout.email-me")}
                  </label>
                </div>
              </>
            )}

            {Object.keys(user).length > 0 && (
              <>
                <h3 className="checkout-login">
                  {t("checkout.choose")}{" "}
                  <Link
                    to="/address-book?to=checkout"
                    className="checkout-login-link"
                  >
                    {t("checkout.or-add-address")}
                  </Link>
                </h3>

                <div className="address-selector">
                  {addressesArr?.length > 0 ? (
                    <SelectWithInnerLabel
                      stateValue={selectedAddress}
                      setStateValue={setSelectedAddress}
                      labelText={t("input.choose-address") + "*"}
                      idText={"address-selector"}
                      options={addressesArr}
                      redBorder={true}
                    />
                  ) : (
                    <h3 className="checkout-login">
                      {t("address-book.you-have-no-addresses")}
                    </h3>
                  )}
                </div>
              </>
            )}

            <div className="checkout-info-personal-information">
              <LoaderOverlay
                loadingState={zonesLoading}
                errorState={zonesError}
                setErrorState={setZonesError}
                retryFunc={zonesRetryFunc}
              />
              <div className="checkout-info-personal-information-title-container">
                <h3 className="checkout-info-personal-information-title">
                  {t("checkout.delivery-address")}
                </h3>
                {Object.keys(user)?.length === 0 &&
                  countriesArr.length > 0 &&
                  !turnMapOff && (
                    <h1
                      className="address-book-map-text"
                      onClick={() => updateAddressFromMap()}
                    >
                      <MapPin /> {t("address-book.detect-via-map")}
                    </h1>
                  )}
              </div>
              {countriesArr.length > 0 && !addressesLoading && (
                <Map
                  updateAddress={updateAddressObject}
                  loadMap={true}
                  selectedPosition={selectedPosition}
                  DisplayName={displayName}
                  userLoggedIn={Object.keys(user)?.length > 0}
                  setTurnMapOff={setTurnMapOff}
                ></Map>
              )}
              {Object.keys(user).length === 0 && (
                <div className="checkout-info-two-fields">
                  <InputWithInnerLabel
                    stateValue={firstName}
                    setStateValue={setFirstName}
                    labelText={t("input.first-name") + "*"}
                    idText={"first-name"}
                    redBorder={true}
                  />
                  <InputWithInnerLabel
                    stateValue={lastName}
                    setStateValue={setLastName}
                    labelText={t("input.last-name") + "*"}
                    idText={"last-name"}
                    redBorder={true}
                  />
                </div>
              )}
              <div className="" style={{ marginTop: "0.5rem" }}></div>
              <SelectWithInnerLabel
                stateValue={country}
                setStateValue={setCountry}
                labelText={t("input.country") + "*"}
                idText={"country-selector"}
                options={countriesArr}
                redBorder={true}
                disabled={Object.keys(user).length > 0}
                locale={true}
              />

              <div className="checkout-info-two-fields">
                <SelectWithInnerLabel
                  stateValue={city}
                  setStateValue={setCity}
                  labelText={t("input.city") + "*"}
                  idText={"city-selector"}
                  options={citiesArr}
                  redBorder={true}
                  disabled={Object.keys(user).length > 0}
                  locale={true}
                />
                <SelectWithInnerLabel
                  stateValue={area}
                  setStateValue={setArea}
                  labelText={t("input.area") + "*"}
                  idText={"area-selector"}
                  options={areasArr}
                  redBorder={true}
                  disabled={Object.keys(user).length > 0}
                  locale={true}
                />
              </div>

              <InputWithInnerLabel
                stateValue={addressLine1}
                setStateValue={setAddressLine1}
                labelText={t("order.address-line-1") + "*"}
                idText={"address-details-one"}
                redBorder={true}
                disabled={Object.keys(user).length > 0}
                minLength={10}
                onChangeRules={isAddressValid}
              />
              <h6 className="example-text">
                {t("checkout.address-book-example")}
              </h6>
              <br />
              <InputWithInnerLabel
                stateValue={addressLine2}
                setStateValue={setAddressLine2}
                labelText={t("order.address-line-2")}
                idText={"address-details-two"}
                disabled={Object.keys(user).length > 0}
                onChangeRules={isAddressValid}
              />
              <InputWithInnerLabel
                stateValue={postalCode}
                setStateValue={setPostalCode}
                labelText={t("input.postal-code") + "*"}
                idText={"postal-code"}
                redBorder={true}
                disabled={Object.keys(user).length > 0}
              />
              {Object.keys(user).length === 0 && (
                <InputWithInnerLabel
                  stateValue={phone}
                  setStateValue={setPhone}
                  type={"tel"}
                  labelText={t("input.phone") + "*"}
                  idText={"phone"}
                  phoneInput={true}
                  updateCountryFromPhoneNumber={updateCountryFromPhoneNumber}
                  redBorder={!isPhoneNumberValid}
                />
              )}
            </div>

            <div className="checkout-info-shipping">
              <LoaderOverlay
                loadingState={
                  shippingProvidersLoading ||
                  (!shippingProvidersError &&
                    !dhlError &&
                    (dhlLoading || CityLoading || AreaLoading))
                }
                errorState={
                  shippingProvidersError
                    ? shippingProvidersError
                    : dhlError
                }
                setErrorState={(value) => {
                  if (shippingProvidersError) {
                    setShippingProvidersError(value);
                  } else {
                    setDhlError(value);
                  }
                }}
                retryFunc={() => {
                  if (shippingProvidersError) {
                    shippingProvidersRetryFunc();
                  } else {
                    retryDHL();
                  }
                }}
              />
              <h3 className="checkout-info-shipping-title">
                {t("checkout.shipping")}
              </h3>
              {/* The overlay above is opaque and covers this block while the
                  address resolves or a quote is in flight, so the list stays
                  mounted and the "no options available" empty state no longer
                  flashes before the shipping option appears. */}
              <RadioBoxCollection
                stateValue={shipping}
                setStateValue={setShipping}
                radioOptions={shippingProvidersArr}
                emptyMessage={t("checkout.add-your-full-address")}
              />
              {shippingProvidersArr?.length > 0 && (
                <h4 class="checkout-info-shipping-subtitle">
                  {t("checkout.customs-note")}
                </h4>
              )}
            </div>

            <div className="checkout-delivery-notes">
              <h3 className="checkout-delivery-notes-title">
                {t("order.delivery-notes")}
              </h3>

              <InputWithInnerLabel
                stateValue={deliveryNotes}
                setStateValue={setDeliveryNotes}
                labelText={t("checkout.example-delivery-notes")}
                idText={"delivery-notes"}
              />
            </div>

            {/*
            <div className="checkout-special-requests">
              <h3 className="checkout-special-requests-title">
                {t("checkout.tailoring-special-requests")}
              </h3>

              <InputWithInnerLabel
                stateValue={specialRequests}
                setStateValue={setSpecialRequests}
                labelText={t("checkout.example-special-requests")}
                idText={"special-requests"}
              />
            </div>
            */}

            {/*
            <div className="checkout-gift-container">
              <div className="show-gift-container">
                <input
                  type="checkbox"
                  id="checkout-info-gift-input"
                  value={showGift}
                  onChange={(e) => {
                    setShowGift(e.target.checked);
                  }}
                />
                <label
                  htmlFor="checkout-info-gift-input"
                  className="checkout-info-gift-label"
                >
                  <span className="show-gift-label">
                    {t("checkout.this-order-is-a-gift")}!
                  </span>
                  <span className="show-git-message">
                    {t("checkout.prints-gift-receipt-on-delivery")}
                  </span>
                </label>
              </div>
              {showGift ? (
                <div className="gift-message-container">
                  <InputWithInnerLabel
                    stateValue={giftMessage}
                    setStateValue={setGiftMessage}
                    labelText={t("checkout.gift-placeholder")}
                    idText={"gift-message"}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
            */}

            {parseFloat(total) !== 0 && (
              <div className="checkout-info-payment">
                <LoaderOverlay
                  loadingState={paymentMethodsLoading}
                  errorState={paymentMethodsError}
                  setErrorState={setPaymentMethodsError}
                  retryFunc={paymentMethodsRetryFunc}
                />
                <h3 className="checkout-info-payment-title">
                  {t("checkout.payment")}
                </h3>
                <h4 className="checkout-info-payment-subtitle">
                  {t("checkout.payment-subtitle")}
                </h4>
                <RadioBoxCollection
                  stateValue={paymentMethod}
                  setStateValue={setPaymentMethod}
                  radioOptions={paymentMethodsArr}
                />
              </div>
            )}
          </div>
        </div>
        <div className="checkout-products-container">
          <LoaderOverlay
            loadingState={areProductsLoading}
            errorState={areProductsError}
            setErrorState={setAreProductsError}
            retryFunc={retryProduct}
          />

          <div className="checkout-products">
            {unavailableProducts?.length > 0 && (
              <div className="checkout-unavailable-note">
                <h3 className="checkout-unavailable-title">
                  {t("checkout.product-unavailable")}
                </h3>
                {unavailableProducts.map((item, index) => (
                  <p key={index} className="checkout-unavailable-item">
                    {t("home.barcode")}: {item?.barcode}
                  </p>
                ))}
              </div>
            )}
            {products?.map((product, index) => {
              return (
                <CartCard key={index} product={product} inCheckout={true} />
              );
            })}
          </div>

          <form className="promo" onSubmit={submitPromo}>
            <div className="promo-form-container">
              <input
                className="promo-input"
                type="text"
                placeholder={t("home.voucher-or-promo-code")}
                value={promoValue}
                onChange={(e) => setPromoValue(e.target.value)}
              />
              <button className="promo-btn" type="submit">
                {t("home.apply")}
              </button>
            </div>
            {showPromoMessage && (
              <h3 className="promo-error">{promoMessage}</h3>
            )}
          </form>

          {Object.keys(user).length > 0 &&
            canRedeem &&
            userPoints > 0 &&
            userPoints > minimumPoints && (
              <form className="redeem-points" onSubmit={submitPointsToRedeem}>
                <h3 className="redeem-points-title">
                  {t("checkout.you-have")} {userPoints}{" "}
                  {t("checkout.redeem-message")}
                </h3>
                <div className="redeem-points-form-container">
                  <input
                    className="redeem-points-input"
                    type="number"
                    placeholder={t("checkout.enter-points-to-redeem")}
                    value={pointsToRedeem}
                    step={0.01}
                    onChange={(e) => setPointsToRedeem(e.target.value)}
                    min={minimumPoints}
                  />
                  <button className="redeem-points-btn" type="submit">
                    {t("checkout.redeem")}
                  </button>
                </div>
                {pointsErrorMessage?.trim() !== "" && (
                  <h3 className="redeem-points-error">{pointsErrorMessage}</h3>
                )}
              </form>
            )}

          <div className="totals">
            {!areProductsLoading && (
              <LoaderOverlay
                loadingState={isPromoLoading}
                errorState={isPromoError}
                setErrorState={setIsPromoError}
                retryFunc={retryPromo}
              />
            )}
            {!areProductsLoading && !isPromoLoading && (
              <LoaderOverlay
                loadingState={isVoucherLoading}
                errorState={isVoucherError}
                setErrorState={setIsVoucherError}
                retryFunc={retryVouchers}
              />
            )}
            <div className="subtotal">
              <span>
                {t("home.subtotal")} . {products?.length} {t("home.items")}
              </span>
              <span>
                <UAEDirham />
                {" "}{country != 231
                  ? (parseFloat(subtotal) + parseFloat(vat)).toFixed(2)
                  : subtotal}
              </span>
            </div>
            <div className="shipping">
              <span>{t("checkout.shipping")}</span>
              {shippingValue == 0 ? (
                <>
                  <span className="no-shipping-available">
                    {t("checkout.no-shipping-options")}
                  </span>
                </>
              ) : (
                <>
                  <span>
                    <UAEDirham /> {shippingValue.toFixed(2)}
                  </span>
                </>
              )}
            </div>
            {country == 231 && (
              <div className="vat">
                <span>{t("home.vat")}</span>
                <span>
                  <UAEDirham /> {vat}
                </span>
              </div>
            )}
            {checkout?.isPromoApplied && (
              <div className="promo-total">
                <span>
                  {checkout?.promo?.attributes?.Name ??
                    checkout?.promo?.attributes?.Code}
                </span>
                <span>
                  - <UAEDirham /> {parseFloat(promoAmountToDeduct).toFixed(2)}
                </span>
              </div>
            )}
            {hasFreeShipping && (
              <div className="promo-total">
                <span>
                  {t("checkout.discount")} - {t("checkout.free-shipping")}
                </span>
                <span>
                  - <UAEDirham /> {shippingValue.toFixed(2)}
                </span>
              </div>
            )}
            {isUsingPoints && pointsTotal > 0 && (
              <div className="promo-total">
                <span>{t("checkout.redeem-total-label")}</span>
                <span>
                  - <UAEDirham /> {pointsTotal.toFixed(2)}
                </span>
              </div>
            )}
            <div className="total">
              <span>{t("home.total")}</span>
              <span>
                <UAEDirham /> {total}
              </span>
            </div>
          </div>

          <div className="place-order-btn-container">
            {errorMessage.trim() !== "" && (
              <h2 className="login-error">{errorMessage}</h2>
            )}
            <button
              className="place-order-btn"
              ref={placeOrderBtn}
              onClick={() => {
                setCheckoutBtnDisabled(true);
                submitOrder();
              }}
              disabled={
                !isFormValid() ||
                unavailableProducts?.length > 0 ||
                checkoutBtnDisabled ||
                foloosiReferenceTokenLoading ||
                placeOrderLoading ||
                updateOrderLoading ||
                NetworkLoading ||
                (!NetworkLoading && NetworkPaymentLink && !NetworkError) ||
                dhlLoading ||
                errorMessage.trim() !== ""
              }
            >
              {unavailableProducts?.length > 0 ? (
                t("checkout.product-unavailable")
              ) : !isFormValid() ? (
                t("checkout.kindly-fill-all-fields")
              ) : (
                <>
                  {!checkoutBtnDisabled &&
                    !foloosiReferenceTokenLoading &&
                    !placeOrderLoading &&
                    !updateOrderLoading &&
                    !NetworkLoading &&
                    !dhlLoading
                    ? t("checkout.place-order")
                    : t("home.loading")}
                </>
              )}
            </button>
            <h2 className="double-check">{t("checkout.double-check")}</h2>
            <div className="agree-to-policies">
              <h2 className="by-placing-order">
                {t("checkout.by-placing-order")}{" "}
                <Link to="/page/payment-and-shipping">
                  {t("checkout.payment-&-shipping")}
                </Link>{" "}
                |{" "}
                <Link to="/page/returns-and-exchanges">
                  {t("checkout.refund-&-return")}
                </Link>{" "}
                |{" "}
                <Link to="/page/shipping-and-delivery-policy">
                  {t("checkout.shipping-&-delivery")}
                </Link>{" "}
                {t("checkout.policies")}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Checkout;

/*
  ADD ORDER ID TO PAYMENT REQUEST: 09 MARCH, 2026
  DESCRIPTION:
  1. Updated 'initiatePayment' in 'useNetworkPayment' hook to accept 'orderId' parameter.
  2. Modified 'handlePayment' in 'Checkout.jsx' to pass 'orderID' (from Redux or local state) 
     to the ngenuis payment API to improve transaction tracking.
*/

/*
  FILTER 'ALL AREAS' OPTION: 27 FEB, 2026
  DESCRIPTION:
  1. Updated 'newAreasArr' to exclude 'All Areas' option for specific countries 
     (Jordan, Lebanon, UAE, KSA, Qatar, Kuwait, Bahrain, Iraq) to ensure shipping accuracy.
*/

/*
  ADD SHIPPING RESPONSE TRACKING: 26 FEB, 2026
  DESCRIPTION: 
  1. Updated 'submitOrder' to initialize 'shippingResponse' during order creation.
  2. Modified 'createOrderShipment' to capture and return the raw API response from DHL, SMSA, and The Net Global.
  3. Enhanced 'updatePaymentResponse' to extract 'shippingResponse' via destructuring and include it in the final order update payload.
*/
